/* =========================================================
   DESIGN INSPIRATION CENTER
   UNISOURCE APPAREL
========================================================= */

(function () {
  "use strict";

  /*
     v62:
     Do NOT block duplicate script instances here.
     If an older script loads first, a singleton guard can prevent the latest
     pagination fix from running. The capture-phase pagination handler below
     is designed to intercept pager clicks before stale bubbling handlers.
  */
  window.__UNISOURCE_DI_ACTIVE_VERSION__ = "v71.0-category-primary-segment-only";

  const CATEGORY_CONFIG = window.UNISOURCE_DESIGN_CATEGORY_PAGE || {};
  const CONFIG = {
    ...CATEGORY_CONFIG,
    pageSize: Number(CATEGORY_CONFIG.pageSize || 12),
    featuredLimit: 0,
  };

  const CATEGORY_NAME = String(CATEGORY_CONFIG.categoryName || "").trim();

  const API_BASE =
    CONFIG.apiBase ||
    "https://shopify-inksoft-poc-node.azurewebsites.net/api/poc/design-inspiration";

  /*
     Matrix JSON exported from the Excel placement/apparel workbook.

     How to use:
     1. Upload design-inspiration-matrix.json to Shopify Files or Azure Blob.
     2. Paste the public JSON URL below, or set it from the page before this script loads:

        window.UNISOURCE_DESIGN_INSPIRATION = {
          matrixUrl: "https://your-json-url/design-inspiration-matrix.json"
        };

     If this stays blank, the page will continue using the built-in apparel/design behavior.
  */
  function addMatrixCacheBust(url) {
    if (!url) return "";

    try {
      const parsed = new URL(url, window.location.href);
      parsed.searchParams.set("_di_matrix_v", String(Date.now()));
      return parsed.toString();
    } catch (error) {
      const joiner = String(url).includes("?") ? "&" : "?";
      return `${url}${joiner}_di_matrix_v=${Date.now()}`;
    }
  }

  function getDefaultMatrixAssetUrl() {
    const script =
      document.currentScript ||
      Array.from(document.scripts).find((item) =>
        String(item.src || "").includes("design-inspiration.js")
      );

    if (!script || !script.src) return "";

    try {
      const url = new URL(script.src);
      url.pathname = url.pathname.replace(/design-inspiration\.js$/i, "design-inspiration-matrix.json");
      return addMatrixCacheBust(url.toString());
    } catch (error) {
      return "";
    }
  }

  const DI_MATRIX_URL = addMatrixCacheBust(
    CONFIG.matrixUrl ||
      CONFIG.designMatrixUrl ||
      getDefaultMatrixAssetUrl()
  );

  /*
     v40 matrix support - JSON-only source, no embedded matrix fallback.

     v35 matrix support.
     This automatically reads design-inspiration-matrix.json from the same
     Shopify theme Assets folder as design-inspiration.js.

     If a page-level CONFIG.matrixUrl is provided, that external URL still takes priority.
     If the JSON cannot be loaded, the embedded fallback matrix will still be used.
  */
  /*
     v40: Matrix JSON is now the single source of truth.
     The embedded fallback matrix has been removed to avoid stale positioning conflicts.
  */
  const EMBEDDED_DESIGN_MATRIX = null;

  const PAGE_SIZE = Math.max(1, Number(CONFIG.pageSize || 12));
  const FEATURED_LIMIT = Math.max(1, Number(CONFIG.featuredLimit || 16));

  const CURATED_APPAREL_LIBRARY = [{"key":"Gildan-2000-White","category":"Short Sleeve T-Shirt","type":"T-Shirt","brand":"Gildan","mfgSku":"2000","productSku":"760","productId":"1010293","styleId":"1106505","defaultStyle":false,"colorFamily":"White","colorName":"White","tone":"Light","productName":"Men's Ultra Cotton® T-Shirt -2000 | Gildan","front":"https://cdn.inksoft.com/images/products/2959/products/00760/White/front/500.png?decache=639164410575970000","back":"https://cdn.inksoft.com/images/products/2959/products/00760/White/back/500.png?decache=639164410575970000","left":"https://cdn.inksoft.com/images/products/2959/products/00760/White/sleeveleft/500.png?decache=639164410575970000","right":"https://cdn.inksoft.com/images/products/2959/products/00760/White/sleeveright/500.png?decache=639164410575970000","views":"Front, Back, Left, Right","designOnlineUrl":"https://shop.unisourceapparel.com/Unisource_Apparel/shop/design-studio/design?productId=1010293&productStyleId=1106505","sizes":"S, M, L, XL, 2XL, 3XL, 4XL, 5XL"},{"key":"Gildan-5000-White","category":"Short Sleeve T-Shirt","type":"T-Shirt","brand":"Gildan","mfgSku":"5000","productSku":"60","productId":"1010290","styleId":"1106313","defaultStyle":false,"colorFamily":"White","colorName":"White","tone":"Light","productName":"Unisex Heavy Cotton™ T-Shirt - 5000 | Gildan","front":"https://cdn.inksoft.com/images/products/2959/products/00060/White/front/500.png?decache=639163636246570000","back":"https://cdn.inksoft.com/images/products/2959/products/00060/White/back/500.png?decache=639163636246570000","left":"https://cdn.inksoft.com/images/products/2959/products/00060/White/sleeveleft/500.png?decache=639163636246570000","right":"https://cdn.inksoft.com/images/products/2959/products/00060/White/sleeveright/500.png?decache=639163636246570000","views":"Front, Back, Left, Right","designOnlineUrl":"https://shop.unisourceapparel.com/Unisource_Apparel/shop/design-studio/design?productId=1010290&productStyleId=1106313","sizes":"S, M, L, XL, 2XL, 3XL, 4XL, 5XL"},{"key":"Hanes-5250-White","category":"Short Sleeve T-Shirt","type":"T-Shirt","brand":"Hanes","mfgSku":"5250","productSku":"700","productId":"1010496","styleId":"1109249","defaultStyle":false,"colorFamily":"White","colorName":"White","tone":"Light","productName":"Unisex Authentic T-Shirt - 5250 | Hanes","front":"https://cdn.inksoft.com/images/products/2959/products/00700/White/front/500.png?decache=639165268891100000","back":"https://cdn.inksoft.com/images/products/2959/products/00700/White/back/500.png?decache=639165268891100000","left":"https://cdn.inksoft.com/images/products/2959/products/00700/White/sleeveleft/500.png?decache=639165268891100000","right":"https://cdn.inksoft.com/images/products/2959/products/00700/White/sleeveright/500.png?decache=639165268891100000","views":"Front, Back, Left, Right","designOnlineUrl":"https://shop.unisourceapparel.com/Unisource_Apparel/shop/design-studio/design?productId=1010496&productStyleId=1109249","sizes":"S, M, L, XL, 2XL, 3XL, 5XL"},{"key":"Gildan-2000-Black","category":"Short Sleeve T-Shirt","type":"T-Shirt","brand":"Gildan","mfgSku":"2000","productSku":"760","productId":"1010293","styleId":"1106473","defaultStyle":false,"colorFamily":"Black","colorName":"Black","tone":"Dark","productName":"Men's Ultra Cotton® T-Shirt -2000 | Gildan","front":"https://cdn.inksoft.com/images/products/2959/products/00760/Black/front/500.png?decache=639164399000570000","back":"https://cdn.inksoft.com/images/products/2959/products/00760/Black/back/500.png?decache=639164399000570000","left":"https://cdn.inksoft.com/images/products/2959/products/00760/Black/sleeveleft/500.png?decache=639164399000570000","right":"https://cdn.inksoft.com/images/products/2959/products/00760/Black/sleeveright/500.png?decache=639164399000570000","views":"Front, Back, Left, Right","designOnlineUrl":"https://shop.unisourceapparel.com/Unisource_Apparel/shop/design-studio/design?productId=1010293&productStyleId=1106473","sizes":"S, M, L, XL, 2XL, 3XL, 4XL, 5XL"},{"key":"Gildan-5000-Black","category":"Short Sleeve T-Shirt","type":"T-Shirt","brand":"Gildan","mfgSku":"5000","productSku":"60","productId":"1010290","styleId":"1106295","defaultStyle":false,"colorFamily":"Black","colorName":"Black","tone":"Dark","productName":"Unisex Heavy Cotton™ T-Shirt - 5000 | Gildan","front":"https://cdn.inksoft.com/images/products/2959/products/00060/Black/front/500.png?decache=639163595279330000","back":"https://cdn.inksoft.com/images/products/2959/products/00060/Black/back/500.png?decache=639163595279330000","left":"https://cdn.inksoft.com/images/products/2959/products/00060/Black/sleeveleft/500.png?decache=639163595279330000","right":"https://cdn.inksoft.com/images/products/2959/products/00060/Black/sleeveright/500.png?decache=639163595279330000","views":"Front, Back, Left, Right","designOnlineUrl":"https://shop.unisourceapparel.com/Unisource_Apparel/shop/design-studio/design?productId=1010290&productStyleId=1106295","sizes":"S, M, L, XL, 2XL, 3XL, 4XL, 5XL"},{"key":"Hanes-5250-Black","category":"Short Sleeve T-Shirt","type":"T-Shirt","brand":"Hanes","mfgSku":"5250","productSku":"700","productId":"1010496","styleId":"1109225","defaultStyle":true,"colorFamily":"Black","colorName":"Black","tone":"Dark","productName":"Unisex Authentic T-Shirt - 5250 | Hanes","front":"https://cdn.inksoft.com/images/products/2959/products/00700/Black/front/500.png?decache=639165249615630000","back":"https://cdn.inksoft.com/images/products/2959/products/00700/Black/back/500.png?decache=639165249615630000","left":"https://cdn.inksoft.com/images/products/2959/products/00700/Black/sleeveleft/500.png?decache=639165249615630000","right":"https://cdn.inksoft.com/images/products/2959/products/00700/Black/sleeveright/500.png?decache=639165249615630000","views":"Front, Back, Left, Right","designOnlineUrl":"https://shop.unisourceapparel.com/Unisource_Apparel/shop/design-studio/design?productId=1010496&productStyleId=1109225","sizes":"S, M, L, XL, 2XL, 3XL, 5XL"},{"key":"Gildan-2000-Ash","category":"Short Sleeve T-Shirt","type":"T-Shirt","brand":"Gildan","mfgSku":"2000","productSku":"760","productId":"1010293","styleId":"1106471","defaultStyle":true,"colorFamily":"Grey","colorName":"Ash","tone":"Light","productName":"Men's Ultra Cotton® T-Shirt -2000 | Gildan","front":"https://cdn.inksoft.com/images/products/2959/products/00760/Ash/front/500.png?decache=639164399000570000","back":"https://cdn.inksoft.com/images/products/2959/products/00760/Ash/back/500.png?decache=639164399000570000","left":"https://cdn.inksoft.com/images/products/2959/products/00760/Ash/sleeveleft/500.png?decache=639164399000570000","right":"https://cdn.inksoft.com/images/products/2959/products/00760/Ash/sleeveright/500.png?decache=639164399000570000","views":"Front, Back, Left, Right","designOnlineUrl":"https://shop.unisourceapparel.com/Unisource_Apparel/shop/design-studio/design?productId=1010293&productStyleId=1106471","sizes":"S, M, L, XL, 2XL, 3XL, 4XL, 5XL"},{"key":"Gildan-2000-Sport Grey","category":"Short Sleeve T-Shirt","type":"T-Shirt","brand":"Gildan","mfgSku":"2000","productSku":"760","productId":"1010293","styleId":"1106500","defaultStyle":false,"colorFamily":"Grey","colorName":"Sport Grey","tone":"Light","productName":"Men's Ultra Cotton® T-Shirt -2000 | Gildan","front":"https://cdn.inksoft.com/images/products/2959/products/00760/Sport_Grey/front/500.png?decache=639164461542370000","back":"https://cdn.inksoft.com/images/products/2959/products/00760/Sport_Grey/back/500.png?decache=639164461542370000","left":"https://cdn.inksoft.com/images/products/2959/products/00760/Sport_Grey/sleeveleft/500.png?decache=639164461542370000","right":"https://cdn.inksoft.com/images/products/2959/products/00760/Sport_Grey/sleeveright/500.png?decache=639164461542370000","views":"Front, Back, Left, Right","designOnlineUrl":"https://shop.unisourceapparel.com/Unisource_Apparel/shop/design-studio/design?productId=1010293&productStyleId=1106500","sizes":"S, M, L, XL, 2XL, 3XL, 4XL, 5XL"},{"key":"Gildan-5000-Graphite Heather","category":"Short Sleeve T-Shirt","type":"T-Shirt","brand":"Gildan","mfgSku":"5000","productSku":"60","productId":"1010290","styleId":"1106361","defaultStyle":false,"colorFamily":"Grey","colorName":"Graphite Heather","tone":"Heather","productName":"Unisex Heavy Cotton™ T-Shirt - 5000 | Gildan","front":"https://cdn.inksoft.com/images/products/2959/products/00060/Graphite_Heather/front/500.png?decache=639163603217370000","back":"https://cdn.inksoft.com/images/products/2959/products/00060/Graphite_Heather/back/500.png?decache=639163603217370000","left":"https://cdn.inksoft.com/images/products/2959/products/00060/Graphite_Heather/sleeveleft/500.png?decache=639163603217370000","right":"https://cdn.inksoft.com/images/products/2959/products/00060/Graphite_Heather/sleeveright/500.png?decache=639163603217370000","views":"Front, Back, Left, Right","designOnlineUrl":"https://shop.unisourceapparel.com/Unisource_Apparel/shop/design-studio/design?productId=1010290&productStyleId=1106361","sizes":"S, M, L, XL, 2XL, 3XL, 4XL, 5XL"},{"key":"Gildan-5000-Sport Grey","category":"Short Sleeve T-Shirt","type":"T-Shirt","brand":"Gildan","mfgSku":"5000","productSku":"60","productId":"1010290","styleId":"1106310","defaultStyle":false,"colorFamily":"Grey","colorName":"Sport Grey","tone":"Light","productName":"Unisex Heavy Cotton™ T-Shirt - 5000 | Gildan","front":"https://cdn.inksoft.com/images/products/2959/products/00060/Sport_Grey/front/500.png?decache=639163633035300000","back":"https://cdn.inksoft.com/images/products/2959/products/00060/Sport_Grey/back/500.png?decache=639163633035300000","left":"https://cdn.inksoft.com/images/products/2959/products/00060/Sport_Grey/sleeveleft/500.png?decache=639163633035300000","right":"https://cdn.inksoft.com/images/products/2959/products/00060/Sport_Grey/sleeveright/500.png?decache=639163633035300000","views":"Front, Back, Left, Right","designOnlineUrl":"https://shop.unisourceapparel.com/Unisource_Apparel/shop/design-studio/design?productId=1010290&productStyleId=1106310","sizes":"S, M, L, XL, 2XL, 3XL, 4XL, 5XL"},{"key":"Hanes-5250-Ash","category":"Short Sleeve T-Shirt","type":"T-Shirt","brand":"Hanes","mfgSku":"5250","productSku":"700","productId":"1010496","styleId":"1109252","defaultStyle":false,"colorFamily":"Grey","colorName":"Ash","tone":"Light","productName":"Unisex Authentic T-Shirt - 5250 | Hanes","front":"https://cdn.inksoft.com/images/products/2959/products/00700/Ash/front/500.png?decache=639165249615630000","back":"https://cdn.inksoft.com/images/products/2959/products/00700/Ash/back/500.png?decache=639165249615630000","left":"https://cdn.inksoft.com/images/products/2959/products/00700/Ash/sleeveleft/500.png?decache=639165249615630000","right":"https://cdn.inksoft.com/images/products/2959/products/00700/Ash/sleeveright/500.png?decache=639165249615630000","views":"Front, Back, Left, Right","designOnlineUrl":"https://shop.unisourceapparel.com/Unisource_Apparel/shop/design-studio/design?productId=1010496&productStyleId=1109252","sizes":"S, M, L, XL, 2XL, 3XL"},{"key":"Hanes-5250-Light Steel","category":"Short Sleeve T-Shirt","type":"T-Shirt","brand":"Hanes","mfgSku":"5250","productSku":"700","productId":"1010496","styleId":"1109236","defaultStyle":false,"colorFamily":"Grey","colorName":"Light Steel","tone":"Dark","productName":"Unisex Authentic T-Shirt - 5250 | Hanes","front":"https://cdn.inksoft.com/images/products/2959/products/00700/Light_Steel/front/500.png?decache=639165251995030000","back":"https://cdn.inksoft.com/images/products/2959/products/00700/Light_Steel/back/500.png?decache=639165251995030000","left":"https://cdn.inksoft.com/images/products/2959/products/00700/Light_Steel/sleeveleft/500.png?decache=639165251995030000","right":"https://cdn.inksoft.com/images/products/2959/products/00700/Light_Steel/sleeveright/500.png?decache=639165251995030000","views":"Front, Back, Left, Right","designOnlineUrl":"https://shop.unisourceapparel.com/Unisource_Apparel/shop/design-studio/design?productId=1010496&productStyleId=1109236","sizes":"S, M, L, XL, 2XL, 3XL, 5XL"},{"key":"Hanes-5250-Oxford Grey","category":"Short Sleeve T-Shirt","type":"T-Shirt","brand":"Hanes","mfgSku":"5250","productSku":"700","productId":"1010496","styleId":"1109266","defaultStyle":false,"colorFamily":"Grey","colorName":"Oxford Grey","tone":"Heather","productName":"Unisex Authentic T-Shirt - 5250 | Hanes","front":"https://cdn.inksoft.com/images/products/2959/products/00700/Oxford_Grey/front/500.png?decache=639165251995030000","back":"https://cdn.inksoft.com/images/products/2959/products/00700/Oxford_Grey/back/500.png?decache=639165251995030000","left":"https://cdn.inksoft.com/images/products/2959/products/00700/Oxford_Grey/sleeveleft/500.png?decache=639165251995030000","right":"https://cdn.inksoft.com/images/products/2959/products/00700/Oxford_Grey/sleeveright/500.png?decache=639165251995030000","views":"Front, Back, Left, Right","designOnlineUrl":"https://shop.unisourceapparel.com/Unisource_Apparel/shop/design-studio/design?productId=1010496&productStyleId=1109266","sizes":"S, M, L, XL, 2XL, 3XL, 5XL"},{"key":"Hanes-5250-Smoke Grey","category":"Short Sleeve T-Shirt","type":"T-Shirt","brand":"Hanes","mfgSku":"5250","productSku":"700","productId":"1010496","styleId":"1109260","defaultStyle":false,"colorFamily":"Grey","colorName":"Smoke Grey","tone":"Dark","productName":"Unisex Authentic T-Shirt - 5250 | Hanes","front":"https://cdn.inksoft.com/images/products/2959/products/00700/Smoke_Grey/front/500.png?decache=639165268891100000","back":"https://cdn.inksoft.com/images/products/2959/products/00700/Smoke_Grey/back/500.png?decache=639165268891100000","left":"https://cdn.inksoft.com/images/products/2959/products/00700/Smoke_Grey/sleeveleft/500.png?decache=639165268891100000","right":"https://cdn.inksoft.com/images/products/2959/products/00700/Smoke_Grey/sleeveright/500.png?decache=639165268891100000","views":"Front, Back, Left, Right","designOnlineUrl":"https://shop.unisourceapparel.com/Unisource_Apparel/shop/design-studio/design?productId=1010496&productStyleId=1109260","sizes":"S, M, L, XL, 2XL, 3XL"},{"key":"Gildan-2000-Royal","category":"Short Sleeve T-Shirt","type":"T-Shirt","brand":"Gildan","mfgSku":"2000","productSku":"760","productId":"1010293","styleId":"1106496","defaultStyle":false,"colorFamily":"Royal","colorName":"Royal","tone":"Dark","productName":"Men's Ultra Cotton® T-Shirt -2000 | Gildan","front":"https://cdn.inksoft.com/images/products/2959/products/00760/Royal/front/500.png?decache=639164410575970000","back":"https://cdn.inksoft.com/images/products/2959/products/00760/Royal/back/500.png?decache=639164410575970000","left":"https://cdn.inksoft.com/images/products/2959/products/00760/Royal/sleeveleft/500.png?decache=639164410575970000","right":"https://cdn.inksoft.com/images/products/2959/products/00760/Royal/sleeveright/500.png?decache=639164410575970000","views":"Front, Back, Left, Right","designOnlineUrl":"https://shop.unisourceapparel.com/Unisource_Apparel/shop/design-studio/design?productId=1010293&productStyleId=1106496","sizes":"S, M, L, XL, 2XL, 3XL, 4XL, 5XL"},{"key":"Gildan-5000-Royal","category":"Short Sleeve T-Shirt","type":"T-Shirt","brand":"Gildan","mfgSku":"5000","productSku":"60","productId":"1010290","styleId":"1106306","defaultStyle":false,"colorFamily":"Royal","colorName":"Royal","tone":"Dark","productName":"Unisex Heavy Cotton™ T-Shirt - 5000 | Gildan","front":"https://cdn.inksoft.com/images/products/2959/products/00060/Royal/front/500.png?decache=639163633035300000","back":"https://cdn.inksoft.com/images/products/2959/products/00060/Royal/back/500.png?decache=639163633035300000","left":"https://cdn.inksoft.com/images/products/2959/products/00060/Royal/sleeveleft/500.png?decache=639163633035300000","right":"https://cdn.inksoft.com/images/products/2959/products/00060/Royal/sleeveright/500.png?decache=639163633035300000","views":"Front, Back, Left, Right","designOnlineUrl":"https://shop.unisourceapparel.com/Unisource_Apparel/shop/design-studio/design?productId=1010290&productStyleId=1106306","sizes":"S, M, L, XL, 2XL, 3XL, 4XL, 5XL"},{"key":"Hanes-5250-Deep Royal","category":"Short Sleeve T-Shirt","type":"T-Shirt","brand":"Hanes","mfgSku":"5250","productSku":"700","productId":"1010496","styleId":"1109232","defaultStyle":false,"colorFamily":"Royal","colorName":"Deep Royal","tone":"Dark","productName":"Unisex Authentic T-Shirt - 5250 | Hanes","front":"https://cdn.inksoft.com/images/products/2959/products/00700/Deep_Royal/front/500.png?decache=639165249615630000","back":"https://cdn.inksoft.com/images/products/2959/products/00700/Deep_Royal/back/500.png?decache=639165249615630000","left":"https://cdn.inksoft.com/images/products/2959/products/00700/Deep_Royal/sleeveleft/500.png?decache=639165249615630000","right":"https://cdn.inksoft.com/images/products/2959/products/00700/Deep_Royal/sleeveright/500.png?decache=639165249615630000","views":"Front, Back, Left, Right","designOnlineUrl":"https://shop.unisourceapparel.com/Unisource_Apparel/shop/design-studio/design?productId=1010496&productStyleId=1109232","sizes":"S, M, L, XL, 2XL, 3XL"},{"key":"Gildan-2000-Navy","category":"Short Sleeve T-Shirt","type":"T-Shirt","brand":"Gildan","mfgSku":"2000","productSku":"760","productId":"1010293","styleId":"1106490","defaultStyle":false,"colorFamily":"Navy","colorName":"Navy","tone":"Dark","productName":"Men's Ultra Cotton® T-Shirt -2000 | Gildan","front":"https://cdn.inksoft.com/images/products/2959/products/00760/Navy/front/500.png?decache=639164461542370000","back":"https://cdn.inksoft.com/images/products/2959/products/00760/Navy/back/500.png?decache=639164461542370000","left":"https://cdn.inksoft.com/images/products/2959/products/00760/Navy/sleeveleft/500.png?decache=639164461542370000","right":"https://cdn.inksoft.com/images/products/2959/products/00760/Navy/sleeveright/500.png?decache=639164461542370000","views":"Front, Back, Left, Right","designOnlineUrl":"https://shop.unisourceapparel.com/Unisource_Apparel/shop/design-studio/design?productId=1010293&productStyleId=1106490","sizes":"S, M, L, XL, 2XL, 3XL, 4XL, 5XL"},{"key":"Gildan-5000-Navy","category":"Short Sleeve T-Shirt","type":"T-Shirt","brand":"Gildan","mfgSku":"5000","productSku":"60","productId":"1010290","styleId":"1106304","defaultStyle":false,"colorFamily":"Navy","colorName":"Navy","tone":"Dark","productName":"Unisex Heavy Cotton™ T-Shirt - 5000 | Gildan","front":"https://cdn.inksoft.com/images/products/2959/products/00060/Navy/front/500.png?decache=639163625678330000","back":"https://cdn.inksoft.com/images/products/2959/products/00060/Navy/back/500.png?decache=639163625678330000","left":"https://cdn.inksoft.com/images/products/2959/products/00060/Navy/sleeveleft/500.png?decache=639163625678330000","right":"https://cdn.inksoft.com/images/products/2959/products/00060/Navy/sleeveright/500.png?decache=639163625678330000","views":"Front, Back, Left, Right","designOnlineUrl":"https://shop.unisourceapparel.com/Unisource_Apparel/shop/design-studio/design?productId=1010290&productStyleId=1106304","sizes":"S, M, L, XL, 2XL, 3XL, 4XL, 5XL"},{"key":"Hanes-5250-Navy","category":"Short Sleeve T-Shirt","type":"T-Shirt","brand":"Hanes","mfgSku":"5250","productSku":"700","productId":"1010496","styleId":"1109240","defaultStyle":false,"colorFamily":"Navy","colorName":"Navy","tone":"Dark","productName":"Unisex Authentic T-Shirt - 5250 | Hanes","front":"https://cdn.inksoft.com/images/products/2959/products/00700/Navy/front/500.png?decache=639165251995030000","back":"https://cdn.inksoft.com/images/products/2959/products/00700/Navy/back/500.png?decache=639165251995030000","left":"https://cdn.inksoft.com/images/products/2959/products/00700/Navy/sleeveleft/500.png?decache=639165251995030000","right":"https://cdn.inksoft.com/images/products/2959/products/00700/Navy/sleeveright/500.png?decache=639165251995030000","views":"Front, Back, Left, Right","designOnlineUrl":"https://shop.unisourceapparel.com/Unisource_Apparel/shop/design-studio/design?productId=1010496&productStyleId=1109240","sizes":"S, M, L, XL, 2XL, 3XL, 5XL"},{"key":"Port & Co-KP55-White","category":"Polo","type":"Polo-Basic","brand":"Port & Company","mfgSku":"KP55","productSku":"KP55","productId":"1003445","styleId":"1034735","defaultStyle":false,"colorFamily":"White","colorName":"White","tone":"Light","productName":"5.5-Ounce Jersey Knit Polo - KP55 | Port & Company","front":"https://cdn.inksoft.com/images/products/2959/products/KP55/White/front/500.png?decache=637751052838700000","back":"https://cdn.inksoft.com/images/products/2959/products/KP55/White/back/500.png?decache=637751052838700000","left":"https://cdn.inksoft.com/images/products/2959/products/KP55/White/sleeveleft/500.png?decache=637751052838700000","right":"https://cdn.inksoft.com/images/products/2959/products/KP55/White/sleeveright/500.png?decache=637751052838700000","views":"Front, Back, Left, Right","designOnlineUrl":"https://shop.unisourceapparel.com/Unisource_Apparel/shop/design-studio/design?productId=1003445&productStyleId=1034735","sizes":"XS, S, M, L, XL, 2XL, 3XL, 4XL, 5XL, 6XL"},{"key":"Sport-Tek-ST640-White","category":"Polo","type":"Polo-Performance","brand":"Sport-Tek","mfgSku":"ST640","productSku":"ST640","productId":"1006598","styleId":"1059553","defaultStyle":false,"colorFamily":"White","colorName":"White","tone":"Light","productName":"PosiCharge RacerMesh Polo - ST640 | Sport-Tek","front":"https://cdn.inksoft.com/images/products/2959/products/ST640/White/front/500.png?decache=637574978501970000","back":"https://cdn.inksoft.com/images/products/2959/products/ST640/White/back/500.png?decache=637574978501970000","left":"https://cdn.inksoft.com/images/products/756/products/ST640/White/sleeveleft/500.png?decache=637574978501970000","right":"https://cdn.inksoft.com/images/products/2959/products/ST640/White/sleeveright/500.png?decache=637574978501970000","views":"Front, Back, Left, Right","designOnlineUrl":"https://shop.unisourceapparel.com/Unisource_Apparel/shop/design-studio/design?productId=1006598&productStyleId=1059553","sizes":"XS, S, M, L, XL, 2XL, 3XL, 4XL"},{"key":"Port & Co-KP55-Jet Black","category":"Polo","type":"Polo-Basic","brand":"Port & Company","mfgSku":"KP55","productSku":"KP55","productId":"1003445","styleId":"1034721","defaultStyle":false,"colorFamily":"Black","colorName":"Jet Black","tone":"Dark","productName":"5.5-Ounce Jersey Knit Polo - KP55 | Port & Company","front":"https://cdn.inksoft.com/images/products/2959/products/KP55/Jet_Black/front/500.png?decache=637751050944070000","back":"https://cdn.inksoft.com/images/products/2959/products/KP55/Jet_Black/back/500.png?decache=637751050944070000","left":"https://cdn.inksoft.com/images/products/2959/products/KP55/Jet_Black/sleeveleft/500.png?decache=637751050944070000","right":"https://cdn.inksoft.com/images/products/2959/products/KP55/Jet_Black/sleeveright/500.png?decache=637751050944070000","views":"Front, Back, Left, Right","designOnlineUrl":"https://shop.unisourceapparel.com/Unisource_Apparel/shop/design-studio/design?productId=1003445&productStyleId=1034721","sizes":"XS, S, M, L, XL, 2XL, 3XL, 4XL, 5XL, 6XL"},{"key":"Sport-Tek-ST640-Black","category":"Polo","type":"Polo-Performance","brand":"Sport-Tek","mfgSku":"ST640","productSku":"ST640","productId":"1006598","styleId":"1059551","defaultStyle":false,"colorFamily":"Black","colorName":"Black","tone":"Dark","productName":"PosiCharge RacerMesh Polo - ST640 | Sport-Tek","front":"https://cdn.inksoft.com/images/products/2959/products/ST640/Black/front/500.png?decache=638451576861700000","back":"https://cdn.inksoft.com/images/products/2959/products/ST640/Black/back/500.png?decache=638451576861700000","left":"https://cdn.inksoft.com/images/products/756/products/ST640/Black/sleeveleft/500.png?decache=638451576861700000","right":"https://cdn.inksoft.com/images/products/2959/products/ST640/Black/sleeveright/500.png?decache=638451576861700000","views":"Front, Back, Left, Right","designOnlineUrl":"https://shop.unisourceapparel.com/Unisource_Apparel/shop/design-studio/design?productId=1006598&productStyleId=1059551","sizes":"XS, S, M, L, XL, 2XL, 3XL, 4XL"},{"key":"Port & Co-KP55-Ash","category":"Polo","type":"Polo-Basic","brand":"Port & Company","mfgSku":"KP55","productSku":"KP55","productId":"1003445","styleId":"1034736","defaultStyle":false,"colorFamily":"Grey","colorName":"Ash","tone":"Heather","productName":"5.5-Ounce Jersey Knit Polo - KP55 | Port & Company","front":"https://cdn.inksoft.com/images/products/2959/products/KP55/Ash/front/500.png?decache=637751043379070000","back":"https://cdn.inksoft.com/images/products/2959/products/KP55/Ash/back/500.png?decache=637751043379070000","left":"https://cdn.inksoft.com/images/products/2959/products/KP55/Ash/sleeveleft/500.png?decache=637751043379070000","right":"https://cdn.inksoft.com/images/products/2959/products/KP55/Ash/sleeveright/500.png?decache=637751043379070000","views":"Front, Back, Left, Right","designOnlineUrl":"https://shop.unisourceapparel.com/Unisource_Apparel/shop/design-studio/design?productId=1003445&productStyleId=1034736","sizes":"XS, S, M, L, XL, 2XL, 3XL, 4XL, 5XL, 6XL"},{"key":"Port & Co-KP55-Athletic Heather","category":"Polo","type":"Polo-Basic","brand":"Port & Company","mfgSku":"KP55","productSku":"KP55","productId":"1003445","styleId":"1034719","defaultStyle":false,"colorFamily":"Grey","colorName":"Athletic Heather","tone":"Heather","productName":"5.5-Ounce Jersey Knit Polo - KP55 | Port & Company","front":"https://cdn.inksoft.com/images/products/2959/products/KP55/Athletic_Heather/front/500.png?decache=637751043379070000","back":"https://cdn.inksoft.com/images/products/2959/products/KP55/Athletic_Heather/back/500.png?decache=637751043379070000","left":"https://cdn.inksoft.com/images/products/2959/products/KP55/Athletic_Heather/sleeveleft/500.png?decache=637751043379070000","right":"https://cdn.inksoft.com/images/products/2959/products/KP55/Athletic_Heather/sleeveright/500.png?decache=637751043379070000","views":"Front, Back, Left, Right","designOnlineUrl":"https://shop.unisourceapparel.com/Unisource_Apparel/shop/design-studio/design?productId=1003445&productStyleId=1034719","sizes":"XS, S, M, L, XL, 2XL, 3XL, 4XL, 5XL, 6XL"},{"key":"Sport-Tek-ST640-Graphite Grey","category":"Polo","type":"Polo-Performance","brand":"Sport-Tek","mfgSku":"ST640","productSku":"ST640","productId":"1006598","styleId":"1059547","defaultStyle":false,"colorFamily":"Grey","colorName":"Graphite Grey","tone":"Heather","productName":"PosiCharge RacerMesh Polo - ST640 | Sport-Tek","front":"https://cdn.inksoft.com/images/products/2959/products/ST640/Graphite_Grey/front/500.png?decache=638451677892300000","back":"https://cdn.inksoft.com/images/products/2959/products/ST640/Graphite_Grey/back/500.png?decache=638451677892300000","left":"https://cdn.inksoft.com/images/products/756/products/ST640/Graphite_Grey/sleeveleft/500.png?decache=638451677892300000","right":"https://cdn.inksoft.com/images/products/2959/products/ST640/Graphite_Grey/sleeveright/500.png?decache=638451677892300000","views":"Front, Back, Left, Right","designOnlineUrl":"https://shop.unisourceapparel.com/Unisource_Apparel/shop/design-studio/design?productId=1006598&productStyleId=1059547","sizes":"XS, S, M, L, XL, 2XL, 3XL, 4XL"},{"key":"Sport-Tek-ST640-Grey Heather","category":"Polo","type":"Polo-Performance","brand":"Sport-Tek","mfgSku":"ST640","productSku":"ST640","productId":"1006598","styleId":"1059558","defaultStyle":false,"colorFamily":"Grey","colorName":"Grey Heather","tone":"Heather","productName":"PosiCharge RacerMesh Polo - ST640 | Sport-Tek","front":"https://cdn.inksoft.com/images/products/2959/products/ST640/Grey_Heather/front/500.png?decache=638451678893200000","back":"https://cdn.inksoft.com/images/products/2959/products/ST640/Grey_Heather/back/500.png?decache=638451678893200000","left":"https://cdn.inksoft.com/images/products/2959/products/ST640/Grey_Heather/sleeveleft/500.png?decache=638451678893200000","right":"https://cdn.inksoft.com/images/products/2959/products/ST640/Grey_Heather/sleeveright/500.png?decache=638451678893200000","views":"Front, Back, Left, Right","designOnlineUrl":"https://shop.unisourceapparel.com/Unisource_Apparel/shop/design-studio/design?productId=1006598&productStyleId=1059558","sizes":"XS, S, M, L, XL, 2XL, 3XL, 4XL"},{"key":"Sport-Tek-ST640-True Royal","category":"Polo","type":"Polo-Performance","brand":"Sport-Tek","mfgSku":"ST640","productSku":"ST640","productId":"1006598","styleId":"1059550","defaultStyle":false,"colorFamily":"Royal","colorName":"True Royal","tone":"Dark","productName":"PosiCharge RacerMesh Polo - ST640 | Sport-Tek","front":"https://cdn.inksoft.com/images/products/2959/products/ST640/True_Royal/front/500.png?decache=637574978501970000","back":"https://cdn.inksoft.com/images/products/2959/products/ST640/True_Royal/back/500.png?decache=637574978501970000","left":"https://cdn.inksoft.com/images/products/756/products/ST640/True_Royal/sleeveleft/500.png?decache=637574978501970000","right":"https://cdn.inksoft.com/images/products/2959/products/ST640/True_Royal/sleeveright/500.png?decache=637574978501970000","views":"Front, Back, Left, Right","designOnlineUrl":"https://shop.unisourceapparel.com/Unisource_Apparel/shop/design-studio/design?productId=1006598&productStyleId=1059550","sizes":"XS, S, M, L, XL, 2XL, 3XL, 4XL"},{"key":"Sport-Tek-ST640-True Navy","category":"Polo","type":"Polo-Performance","brand":"Sport-Tek","mfgSku":"ST640","productSku":"ST640","productId":"1006598","styleId":"1059554","defaultStyle":false,"colorFamily":"Navy","colorName":"True Navy","tone":"Dark","productName":"PosiCharge RacerMesh Polo - ST640 | Sport-Tek","front":"https://cdn.inksoft.com/images/products/2959/products/ST640/True_Navy/front/500.png?decache=638451602700430000","back":"https://cdn.inksoft.com/images/products/2959/products/ST640/True_Navy/back/500.png?decache=638451602700430000","left":"https://cdn.inksoft.com/images/products/756/products/ST640/True_Navy/sleeveleft/500.png?decache=638451602700430000","right":"https://cdn.inksoft.com/images/products/2959/products/ST640/True_Navy/sleeveright/500.png?decache=638451602700430000","views":"Front, Back, Left, Right","designOnlineUrl":"https://shop.unisourceapparel.com/Unisource_Apparel/shop/design-studio/design?productId=1006598&productStyleId=1059554","sizes":"XS, S, M, L, XL, 2XL, 3XL, 4XL"},{"key":"Gildan-18500-White","category":"Pullover Sweatshirt","type":"Pullover Sweatshirt","brand":"Gildan","mfgSku":"18500","productSku":"22060","productId":"1010285","styleId":"1106147","defaultStyle":false,"colorFamily":"White","colorName":"White","tone":"Light","productName":"Unisex Heavy Blend™ Hooded Sweatshirt - 18500 | Gildan","front":"https://cdn.inksoft.com/images/products/2959/products/22060/White/front/500.png?decache=638863179632500000","back":"https://cdn.inksoft.com/images/products/2959/products/22060/White/back/500.png?decache=638863179632500000","left":"https://cdn.inksoft.com/images/products/2959/products/22060/White/sleeveleft/500.png?decache=638863179632500000","right":"https://cdn.inksoft.com/images/products/2959/products/22060/White/sleeveright/500.png?decache=638863179632500000","views":"Front, Back, Left, Right","designOnlineUrl":"https://shop.unisourceapparel.com/Unisource_Apparel/shop/design-studio/design?productId=1010285&productStyleId=1106147","sizes":"XS, S, M, L, XL, 2XL, 3XL, 4XL, 5XL"},{"key":"Zuni Sportswear-ZS9001-White","category":"Pullover Sweatshirt","type":"Pullover Sweatshirt","brand":"ZUNI Sportswear","mfgSku":"ZS9001","productSku":"ZS9001","productId":"1009867","styleId":"1101160","defaultStyle":false,"colorFamily":"White","colorName":"White","tone":"Light","productName":"Premium Pullover Hoodie - ZS9001 | Zuni Sportswear","front":"https://cdn.inksoft.com/images/products/2959/products/ZS9001/White/front/500.png?decache=639067628509770000","back":"https://cdn.inksoft.com/images/products/2959/products/ZS9001/White/back/500.png?decache=639067628509770000","left":"https://cdn.inksoft.com/images/products/2959/products/ZS9001/White/sleeveleft/500.png?decache=639067628509770000","right":"https://cdn.inksoft.com/images/products/2959/products/ZS9001/White/sleeveright/500.png?decache=639067628509770000","views":"Front, Back, Left, Right","designOnlineUrl":"https://shop.unisourceapparel.com/Unisource_Apparel/shop/design-studio/design?productId=1009867&productStyleId=1101160","sizes":"XS, S, M, L, XL, 2XL, 3XL, 4XL"},{"key":"Cotton-IN-C2001-Black","category":"Pullover Sweatshirt","type":"Pullover Sweatshirt","brand":"Cotton-IN","mfgSku":"C2001D","productSku":"C2001D","productId":"1010331","styleId":"1106965","defaultStyle":false,"colorFamily":"Black","colorName":"Black","tone":"Dark","productName":"Premium Fleece Pullover Hoodie Solid Dark Colors - Cotton-IN | C2001D","front":"https://cdn.inksoft.com/images/products/2959/products/C2001D/Black/front/500.png?decache=638938872793330000","back":"https://cdn.inksoft.com/images/products/2959/products/C2001D/Black/back/500.png?decache=638938872793330000","left":"https://cdn.inksoft.com/images/products/2959/products/C2001D/Black/sleeveleft/500.png?decache=638938872793330000","right":"https://cdn.inksoft.com/images/products/2959/products/C2001D/Black/sleeveright/500.png?decache=638938872793330000","views":"Front, Back, Left, Right","designOnlineUrl":"https://shop.unisourceapparel.com/Unisource_Apparel/shop/design-studio/design?productId=1010331&productStyleId=1106965","sizes":"XS, S, M, L, XL, 2XL, 3XL, 4XL"},{"key":"Gildan-18500-Black","category":"Pullover Sweatshirt","type":"Pullover Sweatshirt","brand":"Gildan","mfgSku":"18500","productSku":"22060","productId":"1010285","styleId":"1106141","defaultStyle":false,"colorFamily":"Black","colorName":"Black","tone":"Dark","productName":"Unisex Heavy Blend™ Hooded Sweatshirt - 18500 | Gildan","front":"https://cdn.inksoft.com/images/products/2959/products/22060/Black/front/500.png?decache=638863163699970000","back":"https://cdn.inksoft.com/images/products/2959/products/22060/Black/back/500.png?decache=638863163699970000","left":"https://cdn.inksoft.com/images/products/2959/products/22060/Black/sleeveleft/500.png?decache=638863163699970000","right":"https://cdn.inksoft.com/images/products/2959/products/22060/Black/sleeveright/500.png?decache=638863163699970000","views":"Front, Back, Left, Right","designOnlineUrl":"https://shop.unisourceapparel.com/Unisource_Apparel/shop/design-studio/design?productId=1010285&productStyleId=1106141","sizes":"XS, S, M, L, XL, 2XL, 3XL, 4XL, 5XL"},{"key":"Zuni Sportswear-ZS9001-Black","category":"Pullover Sweatshirt","type":"Pullover Sweatshirt","brand":"ZUNI Sportswear","mfgSku":"ZS9001","productSku":"ZS9001","productId":"1009867","styleId":"1101153","defaultStyle":false,"colorFamily":"Black","colorName":"Black","tone":"Dark","productName":"Premium Pullover Hoodie - ZS9001 | Zuni Sportswear","front":"https://cdn.inksoft.com/images/products/2959/products/ZS9001/Black/front/500.png?decache=639067628509770000","back":"https://cdn.inksoft.com/images/products/2959/products/ZS9001/Black/back/500.png?decache=639067628509770000","left":"https://cdn.inksoft.com/images/products/2959/products/ZS9001/Black/sleeveleft/500.png?decache=639067628509770000","right":"https://cdn.inksoft.com/images/products/2959/products/ZS9001/Black/sleeveright/500.png?decache=639067628509770000","views":"Front, Back, Left, Right","designOnlineUrl":"https://shop.unisourceapparel.com/Unisource_Apparel/shop/design-studio/design?productId=1009867&productStyleId=1101153","sizes":"XS, S, M, L, XL, 2XL, 3XL, 4XL, 5XL"},{"key":"Gildan-18500-Ash","category":"Pullover Sweatshirt","type":"Pullover Sweatshirt","brand":"Gildan","mfgSku":"18500","productSku":"22060","productId":"1010285","styleId":"1106140","defaultStyle":true,"colorFamily":"Grey","colorName":"Ash","tone":"Light","productName":"Unisex Heavy Blend™ Hooded Sweatshirt - 18500 | Gildan","front":"https://cdn.inksoft.com/images/products/2959/products/22060/Ash/front/500.png?decache=638863163699970000","back":"https://cdn.inksoft.com/images/products/2959/products/22060/Ash/back/500.png?decache=638863163699970000","left":"https://cdn.inksoft.com/images/products/2959/products/22060/Ash/sleeveleft/500.png?decache=638863163699970000","right":"https://cdn.inksoft.com/images/products/2959/products/22060/Ash/sleeveright/500.png?decache=638863163699970000","views":"Front, Back, Left, Right","designOnlineUrl":"https://shop.unisourceapparel.com/Unisource_Apparel/shop/design-studio/design?productId=1010285&productStyleId=1106140","sizes":"XS, S, M, L, XL, 2XL, 3XL, 4XL, 5XL"},{"key":"Gildan-18500-Charcoal","category":"Pullover Sweatshirt","type":"Pullover Sweatshirt","brand":"Gildan","mfgSku":"18500","productSku":"22060","productId":"1010285","styleId":"1106163","defaultStyle":false,"colorFamily":"Grey","colorName":"Charcoal","tone":"Dark","productName":"Unisex Heavy Blend™ Hooded Sweatshirt - 18500 | Gildan","front":"https://cdn.inksoft.com/images/products/2959/products/22060/Charcoal/front/500.png?decache=638863163699970000","back":"https://cdn.inksoft.com/images/products/2959/products/22060/Charcoal/back/500.png?decache=638863163699970000","left":"https://cdn.inksoft.com/images/products/2959/products/22060/Charcoal/sleeveleft/500.png?decache=638863163699970000","right":"https://cdn.inksoft.com/images/products/2959/products/22060/Charcoal/sleeveright/500.png?decache=638863163699970000","views":"Front, Back, Left, Right","designOnlineUrl":"https://shop.unisourceapparel.com/Unisource_Apparel/shop/design-studio/design?productId=1010285&productStyleId=1106163","sizes":"S, M, L, XL, 2XL, 3XL, 4XL, 5XL"},{"key":"Gildan-18500-Dark Heather","category":"Pullover Sweatshirt","type":"Pullover Sweatshirt","brand":"Gildan","mfgSku":"18500","productSku":"22060","productId":"1010285","styleId":"1106161","defaultStyle":false,"colorFamily":"Grey","colorName":"Dark Heather","tone":"Heather","productName":"Unisex Heavy Blend™ Hooded Sweatshirt - 18500 | Gildan","front":"https://cdn.inksoft.com/images/products/2959/products/22060/Dark_Heather/front/500.png?decache=638863163699970000","back":"https://cdn.inksoft.com/images/products/2959/products/22060/Dark_Heather/back/500.png?decache=638863163699970000","left":"https://cdn.inksoft.com/images/products/2959/products/22060/Dark_Heather/sleeveleft/500.png?decache=638863163699970000","right":"https://cdn.inksoft.com/images/products/2959/products/22060/Dark_Heather/sleeveright/500.png?decache=638863163699970000","views":"Front, Back, Left, Right","designOnlineUrl":"https://shop.unisourceapparel.com/Unisource_Apparel/shop/design-studio/design?productId=1010285&productStyleId=1106161","sizes":"XS, S, M, L, XL, 2XL, 3XL, 4XL, 5XL"},{"key":"Gildan-18500-Graphite Heather","category":"Pullover Sweatshirt","type":"Pullover Sweatshirt","brand":"Gildan","mfgSku":"18500","productSku":"22060","productId":"1010285","styleId":"1106172","defaultStyle":false,"colorFamily":"Grey","colorName":"Graphite Heather","tone":"Heather","productName":"Unisex Heavy Blend™ Hooded Sweatshirt - 18500 | Gildan","front":"https://cdn.inksoft.com/images/products/2959/products/22060/Graphite_Heather/front/500.png?decache=638863163699970000","back":"https://cdn.inksoft.com/images/products/2959/products/22060/Graphite_Heather/back/500.png?decache=638863163699970000","left":"https://cdn.inksoft.com/images/products/2959/products/22060/Graphite_Heather/sleeveleft/500.png?decache=638863163699970000","right":"https://cdn.inksoft.com/images/products/2959/products/22060/Graphite_Heather/sleeveright/500.png?decache=638863163699970000","views":"Front, Back, Left, Right","designOnlineUrl":"https://shop.unisourceapparel.com/Unisource_Apparel/shop/design-studio/design?productId=1010285&productStyleId=1106172","sizes":"S, M, L, XL, 2XL, 3XL, 4XL, 5XL"},{"key":"Gildan-18500-Sport Grey","category":"Pullover Sweatshirt","type":"Pullover Sweatshirt","brand":"Gildan","mfgSku":"18500","productSku":"22060","productId":"1010285","styleId":"1106146","defaultStyle":false,"colorFamily":"Grey","colorName":"Sport Grey","tone":"Light","productName":"Unisex Heavy Blend™ Hooded Sweatshirt - 18500 | Gildan","front":"https://cdn.inksoft.com/images/products/2959/products/22060/Sport_Grey/front/500.png?decache=638863179632500000","back":"https://cdn.inksoft.com/images/products/2959/products/22060/Sport_Grey/back/500.png?decache=638863179632500000","left":"https://cdn.inksoft.com/images/products/2959/products/22060/Sport_Grey/sleeveleft/500.png?decache=638863179632500000","right":"https://cdn.inksoft.com/images/products/2959/products/22060/Sport_Grey/sleeveright/500.png?decache=638863179632500000","views":"Front, Back, Left, Right","designOnlineUrl":"https://shop.unisourceapparel.com/Unisource_Apparel/shop/design-studio/design?productId=1010285&productStyleId=1106146","sizes":"XS, S, M, L, XL, 2XL, 3XL, 4XL, 5XL"},{"key":"Zuni Sportswear-ZS9001-Grey Heather","category":"Pullover Sweatshirt","type":"Pullover Sweatshirt","brand":"ZUNI Sportswear","mfgSku":"ZS9001","productSku":"ZS9001","productId":"1009867","styleId":"1101154","defaultStyle":false,"colorFamily":"Grey","colorName":"Grey Heather","tone":"Heather","productName":"Premium Pullover Hoodie - ZS9001 | Zuni Sportswear","front":"https://cdn.inksoft.com/images/products/2959/products/ZS9001/Grey_Heather/front/500.png?decache=639067628509770000","back":"https://cdn.inksoft.com/images/products/2959/products/ZS9001/Grey_Heather/back/500.png?decache=639067628509770000","left":"https://cdn.inksoft.com/images/products/2959/products/ZS9001/Grey_Heather/sleeveleft/500.png?decache=639067628509770000","right":"https://cdn.inksoft.com/images/products/2959/products/ZS9001/Grey_Heather/sleeveright/500.png?decache=639067628509770000","views":"Front, Back, Left, Right","designOnlineUrl":"https://shop.unisourceapparel.com/Unisource_Apparel/shop/design-studio/design?productId=1009867&productStyleId=1101154","sizes":"XS, S, M, L, XL, 2XL, 3XL, 4XL"},{"key":"Cotton-IN-C2001-Deep Royal Blue","category":"Pullover Sweatshirt","type":"Pullover Sweatshirt","brand":"Cotton-IN","mfgSku":"C2001D","productSku":"C2001D","productId":"1010331","styleId":"1106903","defaultStyle":false,"colorFamily":"Royal","colorName":"Deep Royal Blue","tone":"Dark","productName":"Premium Fleece Pullover Hoodie Solid Dark Colors - Cotton-IN | C2001D","front":"https://cdn.inksoft.com/images/products/2959/products/C2001D/Deep_Royal_Blue/front/500.png?decache=638938872793330000","back":"https://cdn.inksoft.com/images/products/2959/products/C2001D/Deep_Royal_Blue/back/500.png?decache=638938872793330000","left":"https://cdn.inksoft.com/images/products/2959/products/C2001D/Deep_Royal_Blue/sleeveleft/500.png?decache=638938872793330000","right":"https://cdn.inksoft.com/images/products/2959/products/C2001D/Deep_Royal_Blue/sleeveright/500.png?decache=638938872793330000","views":"Front, Back, Left, Right","designOnlineUrl":"https://shop.unisourceapparel.com/Unisource_Apparel/shop/design-studio/design?productId=1010331&productStyleId=1106903","sizes":"XS, S, M, L, XL, 2XL, 3XL, 4XL"},{"key":"Gildan-18500-Royal","category":"Pullover Sweatshirt","type":"Pullover Sweatshirt","brand":"Gildan","mfgSku":"18500","productSku":"22060","productId":"1010285","styleId":"1106160","defaultStyle":false,"colorFamily":"Royal","colorName":"Royal","tone":"Dark","productName":"Unisex Heavy Blend™ Hooded Sweatshirt - 18500 | Gildan","front":"https://cdn.inksoft.com/images/products/2959/products/22060/Royal/front/500.png?decache=638863170500500000","back":"https://cdn.inksoft.com/images/products/2959/products/22060/Royal/back/500.png?decache=638863170500500000","left":"https://cdn.inksoft.com/images/products/2959/products/22060/Royal/sleeveleft/500.png?decache=638863170500500000","right":"https://cdn.inksoft.com/images/products/2959/products/22060/Royal/sleeveright/500.png?decache=638863170500500000","views":"Front, Back, Left, Right","designOnlineUrl":"https://shop.unisourceapparel.com/Unisource_Apparel/shop/design-studio/design?productId=1010285&productStyleId=1106160","sizes":"XS, S, M, L, XL, 2XL, 3XL, 4XL, 5XL"},{"key":"Zuni Sportswear-ZS9001-Royal","category":"Pullover Sweatshirt","type":"Pullover Sweatshirt","brand":"ZUNI Sportswear","mfgSku":"ZS9001","productSku":"ZS9001","productId":"1009867","styleId":"1108699","defaultStyle":true,"colorFamily":"Royal","colorName":"Royal","tone":"Dark","productName":"Premium Pullover Hoodie - ZS9001 | Zuni Sportswear","front":"https://cdn.inksoft.com/images/products/2959/products/ZS9001/Royal/front/500.png?decache=639067628509770000","back":"https://cdn.inksoft.com/images/products/2959/products/ZS9001/Royal/back/500.png?decache=639067628509770000","left":"https://cdn.inksoft.com/images/products/2959/products/ZS9001/Royal/sleeveleft/500.png?decache=639067628509770000","right":"https://cdn.inksoft.com/images/products/2959/products/ZS9001/Royal/sleeveright/500.png?decache=639067628509770000","views":"Front, Back, Left, Right","designOnlineUrl":"https://shop.unisourceapparel.com/Unisource_Apparel/shop/design-studio/design?productId=1009867&productStyleId=1108699","sizes":"XS, S, M, L, XL, 2XL, 3XL, 4XL, 5XL"},{"key":"Cotton-IN-C2001-Navy","category":"Pullover Sweatshirt","type":"Pullover Sweatshirt","brand":"Cotton-IN","mfgSku":"C2001D","productSku":"C2001D","productId":"1010331","styleId":"1106898","defaultStyle":true,"colorFamily":"Navy","colorName":"Navy","tone":"Dark","productName":"Premium Fleece Pullover Hoodie Solid Dark Colors - Cotton-IN | C2001D","front":"https://cdn.inksoft.com/images/products/2959/products/C2001D/Navy/front/500.png?decache=638938872793330000","back":"https://cdn.inksoft.com/images/products/2959/products/C2001D/Navy/back/500.png?decache=638938872793330000","left":"https://cdn.inksoft.com/images/products/2959/products/C2001D/Navy/sleeveleft/500.png?decache=638938872793330000","right":"https://cdn.inksoft.com/images/products/2959/products/C2001D/Navy/sleeveright/500.png?decache=638938872793330000","views":"Front, Back, Left, Right","designOnlineUrl":"https://shop.unisourceapparel.com/Unisource_Apparel/shop/design-studio/design?productId=1010331&productStyleId=1106898","sizes":"XS, S, M, L, XL, 2XL, 3XL, 4XL"},{"key":"Gildan-18500-Navy","category":"Pullover Sweatshirt","type":"Pullover Sweatshirt","brand":"Gildan","mfgSku":"18500","productSku":"22060","productId":"1010285","styleId":"1106143","defaultStyle":false,"colorFamily":"Navy","colorName":"Navy","tone":"Dark","productName":"Unisex Heavy Blend™ Hooded Sweatshirt - 18500 | Gildan","front":"https://cdn.inksoft.com/images/products/2959/products/22060/Navy/front/500.png?decache=638863169543030000","back":"https://cdn.inksoft.com/images/products/2959/products/22060/Navy/back/500.png?decache=638863169543030000","left":"https://cdn.inksoft.com/images/products/2959/products/22060/Navy/sleeveleft/500.png?decache=638863169543030000","right":"https://cdn.inksoft.com/images/products/2959/products/22060/Navy/sleeveright/500.png?decache=638863169543030000","views":"Front, Back, Left, Right","designOnlineUrl":"https://shop.unisourceapparel.com/Unisource_Apparel/shop/design-studio/design?productId=1010285&productStyleId=1106143","sizes":"XS, S, M, L, XL, 2XL, 3XL, 4XL, 5XL"},{"key":"Zuni Sportswear-ZS9001-Navy","category":"Pullover Sweatshirt","type":"Pullover Sweatshirt","brand":"ZUNI Sportswear","mfgSku":"ZS9001","productSku":"ZS9001","productId":"1009867","styleId":"1101157","defaultStyle":false,"colorFamily":"Navy","colorName":"Navy","tone":"Dark","productName":"Premium Pullover Hoodie - ZS9001 | Zuni Sportswear","front":"https://cdn.inksoft.com/images/products/2959/products/ZS9001/Navy/front/500.png?decache=639067628509770000","back":"https://cdn.inksoft.com/images/products/2959/products/ZS9001/Navy/back/500.png?decache=639067628509770000","left":"https://cdn.inksoft.com/images/products/2959/products/ZS9001/Navy/sleeveleft/500.png?decache=639067628509770000","right":"https://cdn.inksoft.com/images/products/2959/products/ZS9001/Navy/sleeveright/500.png?decache=639067628509770000","views":"Front, Back, Left, Right","designOnlineUrl":"https://shop.unisourceapparel.com/Unisource_Apparel/shop/design-studio/design?productId=1009867&productStyleId=1101157","sizes":"XS, S, M, L, XL, 2XL, 3XL, 4XL"},{"key":"Gildan-18000-White","category":"Crewneck Shirt","type":"Sweatshirts","brand":"Gildan","mfgSku":"18000","productSku":"21060","productId":"1010281","styleId":"1106091","defaultStyle":false,"colorFamily":"White","colorName":"White","tone":"Light","productName":"Unisex Heavy Blend™ Crewneck Sweatshirt - 18000 | Gildan","front":"https://cdn.inksoft.com/images/products/2959/products/21060/White/front/500.png?decache=638862168935870000","back":"https://cdn.inksoft.com/images/products/2959/products/21060/White/back/500.png?decache=638862168935870000","left":"https://cdn.inksoft.com/images/products/2959/products/21060/White/sleeveleft/500.png?decache=638862168935870000","right":"https://cdn.inksoft.com/images/products/2959/products/21060/White/sleeveright/500.png?decache=638862168935870000","views":"Front, Back, Left, Right","designOnlineUrl":"https://shop.unisourceapparel.com/Unisource_Apparel/shop/design-studio/design?productId=1010281&productStyleId=1106091","sizes":"XS, S, M, L, XL, 2XL, 3XL, 4XL, 5XL"},{"key":"Gildan-18000-Black","category":"Crewneck Shirt","type":"Sweatshirts","brand":"Gildan","mfgSku":"18000","productSku":"21060","productId":"1010281","styleId":"1106084","defaultStyle":false,"colorFamily":"Black","colorName":"Black","tone":"Dark","productName":"Unisex Heavy Blend™ Crewneck Sweatshirt - 18000 | Gildan","front":"https://cdn.inksoft.com/images/products/2959/products/21060/Black/front/500.png?decache=638862136423370000","back":"https://cdn.inksoft.com/images/products/2959/products/21060/Black/back/500.png?decache=638862136423370000","left":"https://cdn.inksoft.com/images/products/2959/products/21060/Black/sleeveleft/500.png?decache=638862136423370000","right":"https://cdn.inksoft.com/images/products/2959/products/21060/Black/sleeveright/500.png?decache=638862136423370000","views":"Front, Back, Left, Right","designOnlineUrl":"https://shop.unisourceapparel.com/Unisource_Apparel/shop/design-studio/design?productId=1010281&productStyleId=1106084","sizes":"XS, S, M, L, XL, 2XL, 3XL, 4XL, 5XL"},{"key":"Gildan-18000-Ash","category":"Crewneck Shirt","type":"Sweatshirts","brand":"Gildan","mfgSku":"18000","productSku":"21060","productId":"1010281","styleId":"1106083","defaultStyle":true,"colorFamily":"Grey","colorName":"Ash","tone":"Light","productName":"Unisex Heavy Blend™ Crewneck Sweatshirt - 18000 | Gildan","front":"https://cdn.inksoft.com/images/products/2959/products/21060/Ash/front/500.png?decache=638862136423370000","back":"https://cdn.inksoft.com/images/products/2959/products/21060/Ash/back/500.png?decache=638862136423370000","left":"https://cdn.inksoft.com/images/products/2959/products/21060/Ash/sleeveleft/500.png?decache=638862136423370000","right":"https://cdn.inksoft.com/images/products/2959/products/21060/Ash/sleeveright/500.png?decache=638862136423370000","views":"Front, Back, Left, Right","designOnlineUrl":"https://shop.unisourceapparel.com/Unisource_Apparel/shop/design-studio/design?productId=1010281&productStyleId=1106083","sizes":"XS, S, M, L, XL, 2XL, 3XL, 4XL, 5XL"},{"key":"Gildan-18000-Graphite Heather","category":"Crewneck Shirt","type":"Sweatshirts","brand":"Gildan","mfgSku":"18000","productSku":"21060","productId":"1010281","styleId":"1106114","defaultStyle":false,"colorFamily":"Grey","colorName":"Graphite Heather","tone":"Heather","productName":"Unisex Heavy Blend™ Crewneck Sweatshirt - 18000 | Gildan","front":"https://cdn.inksoft.com/images/products/2959/products/21060/Graphite_Heather/front/500.png?decache=638862155114570000","back":"https://cdn.inksoft.com/images/products/2959/products/21060/Graphite_Heather/back/500.png?decache=638862155114570000","left":"https://cdn.inksoft.com/images/products/2959/products/21060/Graphite_Heather/sleeveleft/500.png?decache=638862155114570000","right":"https://cdn.inksoft.com/images/products/2959/products/21060/Graphite_Heather/sleeveright/500.png?decache=638862155114570000","views":"Front, Back, Left, Right","designOnlineUrl":"https://shop.unisourceapparel.com/Unisource_Apparel/shop/design-studio/design?productId=1010281&productStyleId=1106114","sizes":"S, M, L, XL, 2XL, 3XL, 4XL, 5XL"},{"key":"Gildan-18000-Sport Grey","category":"Crewneck Shirt","type":"Sweatshirts","brand":"Gildan","mfgSku":"18000","productSku":"21060","productId":"1010281","styleId":"1106090","defaultStyle":false,"colorFamily":"Grey","colorName":"Sport Grey","tone":"Light","productName":"Unisex Heavy Blend™ Crewneck Sweatshirt - 18000 | Gildan","front":"https://cdn.inksoft.com/images/products/2959/products/21060/Sport_Grey/front/500.png?decache=638862168935870000","back":"https://cdn.inksoft.com/images/products/2959/products/21060/Sport_Grey/back/500.png?decache=638862168935870000","left":"https://cdn.inksoft.com/images/products/2959/products/21060/Sport_Grey/sleeveleft/500.png?decache=638862168935870000","right":"https://cdn.inksoft.com/images/products/2959/products/21060/Sport_Grey/sleeveright/500.png?decache=638862168935870000","views":"Front, Back, Left, Right","designOnlineUrl":"https://shop.unisourceapparel.com/Unisource_Apparel/shop/design-studio/design?productId=1010281&productStyleId=1106090","sizes":"XS, S, M, L, XL, 2XL, 3XL, 4XL, 5XL"},{"key":"Gildan-18000-Royal","category":"Crewneck Shirt","type":"Sweatshirts","brand":"Gildan","mfgSku":"18000","productSku":"21060","productId":"1010281","styleId":"1106104","defaultStyle":false,"colorFamily":"Royal","colorName":"Royal","tone":"Dark","productName":"Unisex Heavy Blend™ Crewneck Sweatshirt - 18000 | Gildan","front":"https://cdn.inksoft.com/images/products/2959/products/21060/Royal/front/500.png?decache=638862166661730000","back":"https://cdn.inksoft.com/images/products/2959/products/21060/Royal/back/500.png?decache=638862166661730000","left":"https://cdn.inksoft.com/images/products/2959/products/21060/Royal/sleeveleft/500.png?decache=638862166661730000","right":"https://cdn.inksoft.com/images/products/2959/products/21060/Royal/sleeveright/500.png?decache=638862166661730000","views":"Front, Back, Left, Right","designOnlineUrl":"https://shop.unisourceapparel.com/Unisource_Apparel/shop/design-studio/design?productId=1010281&productStyleId=1106104","sizes":"XS, S, M, L, XL, 2XL, 3XL, 4XL, 5XL"},{"key":"Gildan-18000-Navy","category":"Crewneck Shirt","type":"Sweatshirts","brand":"Gildan","mfgSku":"18000","productSku":"21060","productId":"1010281","styleId":"1106087","defaultStyle":false,"colorFamily":"Navy","colorName":"Navy","tone":"Dark","productName":"Unisex Heavy Blend™ Crewneck Sweatshirt - 18000 | Gildan","front":"https://cdn.inksoft.com/images/products/2959/products/21060/Navy/front/500.png?decache=638862166661730000","back":"https://cdn.inksoft.com/images/products/2959/products/21060/Navy/back/500.png?decache=638862166661730000","left":"https://cdn.inksoft.com/images/products/2959/products/21060/Navy/sleeveleft/500.png?decache=638862166661730000","right":"https://cdn.inksoft.com/images/products/2959/products/21060/Navy/sleeveright/500.png?decache=638862166661730000","views":"Front, Back, Left, Right","designOnlineUrl":"https://shop.unisourceapparel.com/Unisource_Apparel/shop/design-studio/design?productId=1010281&productStyleId=1106087","sizes":"XS, S, M, L, XL, 2XL, 3XL, 4XL, 5XL"},{"key":"Cotton-IN-C2002-White","category":"Zipped Sweatshirt","type":"Sweatshirts","brand":"Cotton-IN","mfgSku":"C2002","productSku":"C2002","productId":"1010330","styleId":"1106921","defaultStyle":false,"colorFamily":"White","colorName":"White","tone":"Light","productName":"Unisex Premium Fleece Zipper Hoodie - Cotton-IN | C2002","front":"https://cdn.inksoft.com/images/products/2959/products/C2002/White/front/500.png?decache=639034969076700000","back":"https://cdn.inksoft.com/images/products/2959/products/C2002/White/back/500.png?decache=639034969076700000","left":"https://cdn.inksoft.com/images/products/2959/products/C2002/White/sleeveleft/500.png?decache=639034969076700000","right":"https://cdn.inksoft.com/images/products/2959/products/C2002/White/sleeveright/500.png?decache=639034969076700000","views":"Front, Back, Left, Right","designOnlineUrl":"https://shop.unisourceapparel.com/Unisource_Apparel/shop/design-studio/design?productId=1010330&productStyleId=1106921","sizes":"XS, S, M, L, XL, 2XL, 3XL"},{"key":"Cotton-IN-C2002-Black","category":"Zipped Sweatshirt","type":"Sweatshirts","brand":"Cotton-IN","mfgSku":"C2002","productSku":"C2002","productId":"1010330","styleId":"1107118","defaultStyle":false,"colorFamily":"Black","colorName":"Black","tone":"Dark","productName":"Unisex Premium Fleece Zipper Hoodie - Cotton-IN | C2002","front":"https://cdn.inksoft.com/images/products/2959/products/C2002/Black/front/500.png?decache=639034969076700000","back":"https://cdn.inksoft.com/images/products/2959/products/C2002/Black/back/500.png?decache=639034969076700000","left":"https://cdn.inksoft.com/images/products/2959/products/C2002/Black/sleeveleft/500.png?decache=639034969076700000","right":"https://cdn.inksoft.com/images/products/2959/products/C2002/Black/sleeveright/500.png?decache=639034969076700000","views":"Front, Back, Left, Right","designOnlineUrl":"https://shop.unisourceapparel.com/Unisource_Apparel/shop/design-studio/design?productId=1010330&productStyleId=1107118","sizes":"XS, S, M, L, XL, 2XL, 3XL"},{"key":"Cotton-IN-C2002-Heather Grey","category":"Zipped Sweatshirt","type":"Sweatshirts","brand":"Cotton-IN","mfgSku":"C2002","productSku":"C2002","productId":"1010330","styleId":"1106923","defaultStyle":false,"colorFamily":"Grey","colorName":"Heather Grey","tone":"Heather","productName":"Unisex Premium Fleece Zipper Hoodie - Cotton-IN | C2002","front":"https://cdn.inksoft.com/images/products/2959/products/C2002/Heather_Grey/front/500.png?decache=639034969076700000","back":"https://cdn.inksoft.com/images/products/2959/products/C2002/Heather_Grey/back/500.png?decache=639034969076700000","left":"https://cdn.inksoft.com/images/products/2959/products/C2002/Heather_Grey/sleeveleft/500.png?decache=639034969076700000","right":"https://cdn.inksoft.com/images/products/2959/products/C2002/Heather_Grey/sleeveright/500.png?decache=639034969076700000","views":"Front, Back, Left, Right","designOnlineUrl":"https://shop.unisourceapparel.com/Unisource_Apparel/shop/design-studio/design?productId=1010330&productStyleId=1106923","sizes":"XS, S, M, L, XL, 2XL, 3XL"},{"key":"Cotton-IN-C2002-Deep Royal Blue","category":"Zipped Sweatshirt","type":"Sweatshirts","brand":"Cotton-IN","mfgSku":"C2002","productSku":"C2002","productId":"1010330","styleId":"1106924","defaultStyle":false,"colorFamily":"Royal","colorName":"Deep Royal Blue","tone":"Dark","productName":"Unisex Premium Fleece Zipper Hoodie - Cotton-IN | C2002","front":"https://cdn.inksoft.com/images/products/2959/products/C2002/Deep_Royal_Blue/front/500.png?decache=639034969076700000","back":"https://cdn.inksoft.com/images/products/2959/products/C2002/Deep_Royal_Blue/back/500.png?decache=639034969076700000","left":"https://cdn.inksoft.com/images/products/2959/products/C2002/Deep_Royal_Blue/sleeveleft/500.png?decache=639034969076700000","right":"https://cdn.inksoft.com/images/products/2959/products/C2002/Deep_Royal_Blue/sleeveright/500.png?decache=639034969076700000","views":"Front, Back, Left, Right","designOnlineUrl":"https://shop.unisourceapparel.com/Unisource_Apparel/shop/design-studio/design?productId=1010330&productStyleId=1106924","sizes":"XS, S, M, L, XL, 2XL, 3XL"},{"key":"Cotton-IN-C2002-Navy","category":"Zipped Sweatshirt","type":"Sweatshirts","brand":"Cotton-IN","mfgSku":"C2002","productSku":"C2002","productId":"1010330","styleId":"1106897","defaultStyle":true,"colorFamily":"Navy","colorName":"Navy","tone":"Dark","productName":"Unisex Premium Fleece Zipper Hoodie - Cotton-IN | C2002","front":"https://cdn.inksoft.com/images/products/2959/products/C2002/Navy/front/500.png?decache=639034967771000000","back":"https://cdn.inksoft.com/images/products/2959/products/C2002/Navy/back/500.png?decache=639034967771000000","left":"https://cdn.inksoft.com/images/products/2959/products/C2002/Navy/sleeveleft/500.png?decache=639034967771000000","right":"https://cdn.inksoft.com/images/products/2959/products/C2002/Navy/sleeveright/500.png?decache=639034967771000000","views":"Front, Back, Left, Right","designOnlineUrl":"https://shop.unisourceapparel.com/Unisource_Apparel/shop/design-studio/design?productId=1010330&productStyleId=1106897","sizes":"XS, S, M, L, XL, 2XL, 3XL"},{"key":"EG Pro-B333-White","category":"Shorts","type":"Short","brand":"EG Pro","mfgSku":"B333","productSku":"B333","productId":"1009035","styleId":"1088148","defaultStyle":false,"colorFamily":"White","colorName":"White","tone":"Light","productName":"Core/Tricot Mesh Men's Short Without Pockets (9\" Inseam) - B333 | EG Pro","front":"https://cdn.inksoft.com/images/products/2959/products/B333/White/front/500.png?decache=639165348002600000","back":"https://cdn.inksoft.com/images/products/2959/products/B333/White/back/500.png?decache=639165348002600000","left":"","right":"","views":"Front, Back","designOnlineUrl":"https://shop.unisourceapparel.com/Unisource_Apparel/shop/design-studio/design?productId=1009035&productStyleId=1088148","sizes":"XS, S, M, L, XL, 2XL, 3XL, 4XL, 5XL"},{"key":"EG Pro-P327-White","category":"Shorts","type":"Short","brand":"EG Pro","mfgSku":"P327","productSku":"P327","productId":"1009040","styleId":"1088203","defaultStyle":false,"colorFamily":"White","colorName":"White","tone":"Light","productName":"Aero Mesh Men's P.E. Short (9\" Inseam)","front":"https://cdn.inksoft.com/images/products/2959/products/P327/White/front/500.png?decache=639165290781000000","back":"https://cdn.inksoft.com/images/products/2959/products/P327/White/back/500.png?decache=639165290781000000","left":"","right":"","views":"Front, Back","designOnlineUrl":"https://shop.unisourceapparel.com/Unisource_Apparel/shop/design-studio/design?productId=1009040&productStyleId=1088203","sizes":"XS, S, M, L, XL, 2XL, 3XL, 4XL, 5XL"},{"key":"Champro-BBS55-Black","category":"Shorts","type":"Short","brand":"Champro","mfgSku":"BBS55","productSku":"BBS55","productId":"1009513","styleId":"1095283","defaultStyle":false,"colorFamily":"Black","colorName":"Black","tone":"Dark","productName":"Dynamic Tricot Mesh Short - BBS55 | Champro","front":"https://cdn.inksoft.com/images/products/2959/products/BBS55/Black/front/500.png?decache=639165312280830000","back":"","left":"","right":"","views":"Front","designOnlineUrl":"https://shop.unisourceapparel.com/Unisource_Apparel/shop/design-studio/design?productId=1009513&productStyleId=1095283","sizes":"Youth S, Youth M, Youth L, Youth XL, Adult S, Adult M, Adult L, Adult XL, Adult 2XL, Adult 3XL"},{"key":"EG Pro-B333-Black","category":"Shorts","type":"Short","brand":"EG Pro","mfgSku":"B333","productSku":"B333","productId":"1009035","styleId":"1088147","defaultStyle":false,"colorFamily":"Black","colorName":"Black","tone":"Dark","productName":"Core/Tricot Mesh Men's Short Without Pockets (9\" Inseam) - B333 | EG Pro","front":"https://cdn.inksoft.com/images/products/2959/products/B333/Black/front/500.png?decache=639165348002600000","back":"https://cdn.inksoft.com/images/products/2959/products/B333/Black/back/500.png?decache=639165348002600000","left":"","right":"","views":"Front, Back","designOnlineUrl":"https://shop.unisourceapparel.com/Unisource_Apparel/shop/design-studio/design?productId=1009035&productStyleId=1088147","sizes":"XS, S, M, L, XL, 2XL, 3XL, 4XL, 5XL"},{"key":"EG Pro-P327-Black","category":"Shorts","type":"Short","brand":"EG Pro","mfgSku":"P327","productSku":"P327","productId":"1009040","styleId":"1088202","defaultStyle":true,"colorFamily":"Black","colorName":"Black","tone":"Dark","productName":"Aero Mesh Men's P.E. Short (9\" Inseam)","front":"https://cdn.inksoft.com/images/products/2959/products/P327/Black/front/500.png?decache=639165289895800000","back":"https://cdn.inksoft.com/images/products/2959/products/P327/Black/back/500.png?decache=639165289895800000","left":"","right":"","views":"Front, Back","designOnlineUrl":"https://shop.unisourceapparel.com/Unisource_Apparel/shop/design-studio/design?productId=1009040&productStyleId=1088202","sizes":"XS, S, M, L, XL, 2XL, 3XL, 4XL, 5XL"},{"key":"EG Pro-B333-Graphite","category":"Shorts","type":"Short","brand":"EG Pro","mfgSku":"B333","productSku":"B333","productId":"1009035","styleId":"1088143","defaultStyle":false,"colorFamily":"Grey","colorName":"Graphite","tone":"Heather","productName":"Core/Tricot Mesh Men's Short Without Pockets (9\" Inseam) - B333 | EG Pro","front":"https://cdn.inksoft.com/images/products/2959/products/B333/Graphite/front/500.png?decache=639165348002600000","back":"https://cdn.inksoft.com/images/products/2959/products/B333/Graphite/back/500.png?decache=639165348002600000","left":"","right":"","views":"Front, Back","designOnlineUrl":"https://shop.unisourceapparel.com/Unisource_Apparel/shop/design-studio/design?productId=1009035&productStyleId=1088143","sizes":"XS, S, M, L, XL, 2XL, 3XL, 4XL, 5XL"},{"key":"EG Pro-B333-Light Grey","category":"Shorts","type":"Short","brand":"EG Pro","mfgSku":"B333","productSku":"B333","productId":"1009035","styleId":"1088140","defaultStyle":true,"colorFamily":"Grey","colorName":"Light Grey","tone":"Heather","productName":"Core/Tricot Mesh Men's Short Without Pockets (9\" Inseam) - B333 | EG Pro","front":"https://cdn.inksoft.com/images/products/2959/products/B333/Light_Grey/front/500.png?decache=639165348002600000","back":"https://cdn.inksoft.com/images/products/2959/products/B333/Light_Grey/back/500.png?decache=639165348002600000","left":"","right":"","views":"Front, Back","designOnlineUrl":"https://shop.unisourceapparel.com/Unisource_Apparel/shop/design-studio/design?productId=1009035&productStyleId=1088140","sizes":"XS, S, M, L, XL, 2XL, 3XL, 4XL, 5XL"},{"key":"EG Pro-P327-Graphite","category":"Shorts","type":"Short","brand":"EG Pro","mfgSku":"P327","productSku":"P327","productId":"1009040","styleId":"1088211","defaultStyle":false,"colorFamily":"Grey","colorName":"Graphite","tone":"Heather","productName":"Aero Mesh Men's P.E. Short (9\" Inseam)","front":"https://cdn.inksoft.com/images/products/2959/products/P327/Graphite/front/500.png?decache=639165289895800000","back":"https://cdn.inksoft.com/images/products/2959/products/P327/Graphite/back/500.png?decache=639165289895800000","left":"","right":"","views":"Front, Back","designOnlineUrl":"https://shop.unisourceapparel.com/Unisource_Apparel/shop/design-studio/design?productId=1009040&productStyleId=1088211","sizes":"XS, S, M, L, XL, 2XL, 3XL, 4XL, 5XL"},{"key":"EG Pro-P327-Light Grey","category":"Shorts","type":"Short","brand":"EG Pro","mfgSku":"P327","productSku":"P327","productId":"1009040","styleId":"1088209","defaultStyle":false,"colorFamily":"Grey","colorName":"Light Grey","tone":"Heather","productName":"Aero Mesh Men's P.E. Short (9\" Inseam)","front":"https://cdn.inksoft.com/images/products/2959/products/P327/Light_Grey/front/500.png?decache=639165290781000000","back":"https://cdn.inksoft.com/images/products/2959/products/P327/Light_Grey/back/500.png?decache=639165290781000000","left":"","right":"","views":"Front, Back","designOnlineUrl":"https://shop.unisourceapparel.com/Unisource_Apparel/shop/design-studio/design?productId=1009040&productStyleId=1088209","sizes":"XS, S, M, L, XL, 2XL, 3XL, 4XL, 5XL"},{"key":"Champro-BBS55-Royal","category":"Shorts","type":"Short","brand":"Champro","mfgSku":"BBS55","productSku":"BBS55","productId":"1009513","styleId":"1095288","defaultStyle":false,"colorFamily":"Royal","colorName":"Royal","tone":"Dark","productName":"Dynamic Tricot Mesh Short - BBS55 | Champro","front":"https://cdn.inksoft.com/images/products/2959/products/BBS55/Royal/front/500.png?decache=639165312280830000","back":"","left":"","right":"","views":"Front","designOnlineUrl":"https://shop.unisourceapparel.com/Unisource_Apparel/shop/design-studio/design?productId=1009513&productStyleId=1095288","sizes":"Youth S, Youth M, Youth L, Youth XL, Adult S, Adult M, Adult L, Adult XL, Adult 2XL, Adult 3XL"},{"key":"EG Pro-B333-Royal","category":"Shorts","type":"Short","brand":"EG Pro","mfgSku":"B333","productSku":"B333","productId":"1009035","styleId":"1088150","defaultStyle":false,"colorFamily":"Royal","colorName":"Royal","tone":"Dark","productName":"Core/Tricot Mesh Men's Short Without Pockets (9\" Inseam) - B333 | EG Pro","front":"https://cdn.inksoft.com/images/products/2959/products/B333/Royal/front/500.png?decache=639165348002600000","back":"https://cdn.inksoft.com/images/products/2959/products/B333/Royal/back/500.png?decache=639165348002600000","left":"","right":"","views":"Front, Back","designOnlineUrl":"https://shop.unisourceapparel.com/Unisource_Apparel/shop/design-studio/design?productId=1009035&productStyleId=1088150","sizes":"XS, S, M, L, XL, 2XL, 3XL, 4XL, 5XL"},{"key":"EG Pro-P327-Royal","category":"Shorts","type":"Short","brand":"EG Pro","mfgSku":"P327","productSku":"P327","productId":"1009040","styleId":"1088204","defaultStyle":false,"colorFamily":"Royal","colorName":"Royal","tone":"Dark","productName":"Aero Mesh Men's P.E. Short (9\" Inseam)","front":"https://cdn.inksoft.com/images/products/2959/products/P327/Royal/front/500.png?decache=639165290781000000","back":"https://cdn.inksoft.com/images/products/2959/products/P327/Royal/back/500.png?decache=639165290781000000","left":"","right":"","views":"Front, Back","designOnlineUrl":"https://shop.unisourceapparel.com/Unisource_Apparel/shop/design-studio/design?productId=1009040&productStyleId=1088204","sizes":"XS, S, M, L, XL, 2XL, 3XL, 4XL, 5XL"},{"key":"Champro-BBS55-Navy","category":"Shorts","type":"Short","brand":"Champro","mfgSku":"BBS55","productSku":"BBS55","productId":"1009513","styleId":"1095291","defaultStyle":true,"colorFamily":"Navy","colorName":"Navy","tone":"Dark","productName":"Dynamic Tricot Mesh Short - BBS55 | Champro","front":"https://cdn.inksoft.com/images/products/2959/products/BBS55/Navy/front/500.png?decache=639165312280830000","back":"","left":"","right":"","views":"Front","designOnlineUrl":"https://shop.unisourceapparel.com/Unisource_Apparel/shop/design-studio/design?productId=1009513&productStyleId=1095291","sizes":"Youth S, Youth M, Youth L, Youth XL, Adult S, Adult M, Adult L, Adult XL, Adult 2XL, Adult 3XL"},{"key":"EG Pro-B333-Navy","category":"Shorts","type":"Short","brand":"EG Pro","mfgSku":"B333","productSku":"B333","productId":"1009035","styleId":"1088153","defaultStyle":false,"colorFamily":"Navy","colorName":"Navy","tone":"Dark","productName":"Core/Tricot Mesh Men's Short Without Pockets (9\" Inseam) - B333 | EG Pro","front":"https://cdn.inksoft.com/images/products/2959/products/B333/Navy/front/500.png?decache=639165348002600000","back":"https://cdn.inksoft.com/images/products/2959/products/B333/Navy/back/500.png?decache=639165348002600000","left":"","right":"","views":"Front, Back","designOnlineUrl":"https://shop.unisourceapparel.com/Unisource_Apparel/shop/design-studio/design?productId=1009035&productStyleId=1088153","sizes":"XS, S, M, L, XL, 2XL, 3XL, 4XL, 5XL"},{"key":"EG Pro-P327-Navy","category":"Shorts","type":"Short","brand":"EG Pro","mfgSku":"P327","productSku":"P327","productId":"1009040","styleId":"1088207","defaultStyle":false,"colorFamily":"Navy","colorName":"Navy","tone":"Dark","productName":"Aero Mesh Men's P.E. Short (9\" Inseam)","front":"https://cdn.inksoft.com/images/products/2959/products/P327/Navy/front/500.png?decache=639165290781000000","back":"https://cdn.inksoft.com/images/products/2959/products/P327/Navy/back/500.png?decache=639165290781000000","left":"","right":"","views":"Front, Back","designOnlineUrl":"https://shop.unisourceapparel.com/Unisource_Apparel/shop/design-studio/design?productId=1009040&productStyleId=1088207","sizes":"XS, S, M, L, XL, 2XL, 3XL, 4XL, 5XL"},{"key":"Gildan-18200-White","category":"Pants","type":"Sweatpants","brand":"Gildan","mfgSku":"18200","productSku":"18200","productId":"1007349","styleId":"1107779","defaultStyle":false,"colorFamily":"White","colorName":"White","tone":"Light","productName":"Unisex Heavy Blend™ Sweatpants - 18200 | Gildan","front":"https://cdn.inksoft.com/images/products/2959/products/18200/White/front/500.png?decache=638985605049900000","back":"https://cdn.inksoft.com/images/products/2959/products/18200/White/back/500.png?decache=638985605049900000","left":"","right":"","views":"Front, Back","designOnlineUrl":"https://shop.unisourceapparel.com/Unisource_Apparel/shop/design-studio/design?productId=1007349&productStyleId=1107779","sizes":"S, M, L, XL, 2XL, 3XL"},{"key":"Jerzees-973M-White","category":"Pants","type":"Sweatpants","brand":"Jerzees","mfgSku":"973M","productSku":"973M","productId":"1006590","styleId":"1084210","defaultStyle":false,"colorFamily":"White","colorName":"White","tone":"Light","productName":"JERZEES NuBlend Sweatpant","front":"https://cdn.inksoft.com/images/products/2959/products/973M/White/front/500.png?decache=637630039667900000","back":"https://cdn.inksoft.com/images/products/2959/products/973M/White/back/500.png?decache=637630039667900000","left":"https://cdn.inksoft.com/images/products/2959/products/973M/White/sleeveleft/500.png?decache=637630039667900000","right":"https://cdn.inksoft.com/images/products/2959/products/973M/White/sleeveright/500.png?decache=637630039667900000","views":"Front, Back, Left, Right","designOnlineUrl":"https://shop.unisourceapparel.com/Unisource_Apparel/shop/design-studio/design?productId=1006590&productStyleId=1084210","sizes":"S, M, L, XL, 2XL, 3XL"},{"key":"Zuni Sportswear-ZS9006-White","category":"Pants","type":"Jogger","brand":"ZUNI Sportswear","mfgSku":"ZS9006","productSku":"ZS9006","productId":"1009869","styleId":"1101181","defaultStyle":false,"colorFamily":"White","colorName":"White","tone":"Light","productName":"Premium Jogger Pants","front":"https://cdn.inksoft.com/images/products/2959/products/ZS9006/White/front/500.png?decache=638381101986800000","back":"https://cdn.inksoft.com/images/products/2959/products/ZS9006/White/back/500.png?decache=638381101986800000","left":"https://cdn.inksoft.com/images/products/2959/products/ZS9006/White/sleeveleft/500.png?decache=638381101986800000","right":"https://cdn.inksoft.com/images/products/2959/products/ZS9006/White/sleeveright/500.png?decache=638381101986800000","views":"Front, Back, Left, Right","designOnlineUrl":"https://shop.unisourceapparel.com/Unisource_Apparel/shop/design-studio/design?productId=1009869&productStyleId=1101181","sizes":"XS, S, M, L, XL, 2XL, 3XL"},{"key":"Gildan-18200-Black","category":"Pants","type":"Sweatpants","brand":"Gildan","mfgSku":"18200","productSku":"18200","productId":"1007349","styleId":"1066052","defaultStyle":false,"colorFamily":"Black","colorName":"Black","tone":"Dark","productName":"Unisex Heavy Blend™ Sweatpants - 18200 | Gildan","front":"https://cdn.inksoft.com/images/products/2959/products/18200/Black/front/500.png?decache=638863013578430000","back":"https://cdn.inksoft.com/images/products/2959/products/18200/Black/back/500.png?decache=638863013578430000","left":"","right":"","views":"Front, Back","designOnlineUrl":"https://shop.unisourceapparel.com/Unisource_Apparel/shop/design-studio/design?productId=1007349&productStyleId=1066052","sizes":"S, M, L, XL, 2XL, 3XL"},{"key":"Jerzees-973M-Black","category":"Pants","type":"Sweatpants","brand":"Jerzees","mfgSku":"973M","productSku":"973M","productId":"1006590","styleId":"1059456","defaultStyle":false,"colorFamily":"Black","colorName":"Black","tone":"Dark","productName":"JERZEES NuBlend Sweatpant","front":"https://cdn.inksoft.com/images/products/2959/products/973M/Black/front/500.png?decache=637630039667900000","back":"https://cdn.inksoft.com/images/products/2959/products/973M/Black/back/500.png?decache=637630039667900000","left":"https://cdn.inksoft.com/images/products/2959/products/973M/Black/sleeveleft/500.png?decache=637630039667900000","right":"https://cdn.inksoft.com/images/products/2959/products/973M/Black/sleeveright/500.png?decache=637630039667900000","views":"Front, Back, Left, Right","designOnlineUrl":"https://shop.unisourceapparel.com/Unisource_Apparel/shop/design-studio/design?productId=1006590&productStyleId=1059456","sizes":"S, M, L, XL, 2XL"},{"key":"Zuni Sportswear-ZS9006-Black","category":"Pants","type":"Jogger","brand":"ZUNI Sportswear","mfgSku":"ZS9006","productSku":"ZS9006","productId":"1009869","styleId":"1101180","defaultStyle":false,"colorFamily":"Black","colorName":"Black","tone":"Dark","productName":"Premium Jogger Pants","front":"https://cdn.inksoft.com/images/products/2959/products/ZS9006/Black/front/500.png?decache=638381099948600000","back":"https://cdn.inksoft.com/images/products/2959/products/ZS9006/Black/back/500.png?decache=638381099948600000","left":"https://cdn.inksoft.com/images/products/2959/products/ZS9006/Black/sleeveleft/500.png?decache=638381099948600000","right":"https://cdn.inksoft.com/images/products/2959/products/ZS9006/Black/sleeveright/500.png?decache=638381099948600000","views":"Front, Back, Left, Right","designOnlineUrl":"https://shop.unisourceapparel.com/Unisource_Apparel/shop/design-studio/design?productId=1009869&productStyleId=1101180","sizes":"XS, S, M, L, XL, 2XL, 3XL"},{"key":"Gildan-18200-Ash","category":"Pants","type":"Sweatpants","brand":"Gildan","mfgSku":"18200","productSku":"18200","productId":"1007349","styleId":"1066051","defaultStyle":true,"colorFamily":"Grey","colorName":"Ash","tone":"Light","productName":"Unisex Heavy Blend™ Sweatpants - 18200 | Gildan","front":"https://cdn.inksoft.com/images/products/2959/products/18200/Ash/front/500.png?decache=638863013578430000","back":"https://cdn.inksoft.com/images/products/2959/products/18200/Ash/back/500.png?decache=638863013578430000","left":"","right":"","views":"Front, Back","designOnlineUrl":"https://shop.unisourceapparel.com/Unisource_Apparel/shop/design-studio/design?productId=1007349&productStyleId=1066051","sizes":"S, M, L, XL, 2XL, 3XL"},{"key":"Gildan-18200-Sport Grey","category":"Pants","type":"Sweatpants","brand":"Gildan","mfgSku":"18200","productSku":"18200","productId":"1007349","styleId":"1066056","defaultStyle":false,"colorFamily":"Grey","colorName":"Sport Grey","tone":"Light","productName":"Unisex Heavy Blend™ Sweatpants - 18200 | Gildan","front":"https://cdn.inksoft.com/images/products/464/products/23060/Sport_Grey/front/500.png?decache=637751076298170000","back":"https://cdn.inksoft.com/images/products/464/products/23060/Sport_Grey/back/500.png?decache=637751076298170000","left":"","right":"","views":"Front, Back","designOnlineUrl":"https://shop.unisourceapparel.com/Unisource_Apparel/shop/design-studio/design?productId=1007349&productStyleId=1066056","sizes":"S, M, L, XL, 2XL, 3XL"},{"key":"Jerzees-973M-Ash","category":"Pants","type":"Sweatpants","brand":"Jerzees","mfgSku":"973M","productSku":"973M","productId":"1006590","styleId":"1084216","defaultStyle":false,"colorFamily":"Grey","colorName":"Ash","tone":"Heather","productName":"JERZEES NuBlend Sweatpant","front":"https://cdn.inksoft.com/images/products/2959/products/973M/Ash/front/500.png?decache=637630039667900000","back":"https://cdn.inksoft.com/images/products/2959/products/973M/Ash/back/500.png?decache=637630039667900000","left":"https://cdn.inksoft.com/images/products/2959/products/973M/Ash/sleeveleft/500.png?decache=637630039667900000","right":"https://cdn.inksoft.com/images/products/2959/products/973M/Ash/sleeveright/500.png?decache=637630039667900000","views":"Front, Back, Left, Right","designOnlineUrl":"https://shop.unisourceapparel.com/Unisource_Apparel/shop/design-studio/design?productId=1006590&productStyleId=1084216","sizes":"S, M, L, XL, 2XL, 3XL"},{"key":"Jerzees-973M-Athletic Heather","category":"Pants","type":"Sweatpants","brand":"Jerzees","mfgSku":"973M","productSku":"973M","productId":"1006590","styleId":"1084215","defaultStyle":false,"colorFamily":"Grey","colorName":"Athletic Heather","tone":"Heather","productName":"JERZEES NuBlend Sweatpant","front":"https://cdn.inksoft.com/images/products/2959/products/973M/Athletic_Heather/front/500.png?decache=637630039667900000","back":"https://cdn.inksoft.com/images/products/2959/products/973M/Athletic_Heather/back/500.png?decache=637630039667900000","left":"https://cdn.inksoft.com/images/products/2959/products/973M/Athletic_Heather/sleeveleft/500.png?decache=637630039667900000","right":"https://cdn.inksoft.com/images/products/2959/products/973M/Athletic_Heather/sleeveright/500.png?decache=637630039667900000","views":"Front, Back, Left, Right","designOnlineUrl":"https://shop.unisourceapparel.com/Unisource_Apparel/shop/design-studio/design?productId=1006590&productStyleId=1084215","sizes":"S, M, L, XL, 2XL, 3XL"},{"key":"Zuni Sportswear-ZS9006-Heather Grey","category":"Pants","type":"Jogger","brand":"ZUNI Sportswear","mfgSku":"ZS9006","productSku":"ZS9006","productId":"1009869","styleId":"1101170","defaultStyle":true,"colorFamily":"Grey","colorName":"Heather Grey","tone":"Heather","productName":"Premium Jogger Pants","front":"https://cdn.inksoft.com/images/products/2959/products/ZS9006/Heather_Grey/front/500.png?decache=638381094067430000","back":"https://cdn.inksoft.com/images/products/2959/products/ZS9006/Heather_Grey/back/500.png?decache=638381094067430000","left":"https://cdn.inksoft.com/images/products/2959/products/ZS9006/Heather_Grey/sleeveleft/500.png?decache=638381094067430000","right":"https://cdn.inksoft.com/images/products/2959/products/ZS9006/Heather_Grey/sleeveright/500.png?decache=638381094067430000","views":"Front, Back, Left, Right","designOnlineUrl":"https://shop.unisourceapparel.com/Unisource_Apparel/shop/design-studio/design?productId=1009869&productStyleId=1101170","sizes":"XS, S, M, L, XL, 2XL, 3XL"},{"key":"Jerzees-973M-Royal","category":"Pants","type":"Sweatpants","brand":"Jerzees","mfgSku":"973M","productSku":"973M","productId":"1006590","styleId":"1082452","defaultStyle":false,"colorFamily":"Royal","colorName":"Royal","tone":"Dark","productName":"JERZEES NuBlend Sweatpant","front":"https://cdn.inksoft.com/images/products/2959/products/973M/Royal/front/500.png?decache=637630039667900000","back":"https://cdn.inksoft.com/images/products/2959/products/973M/Royal/back/500.png?decache=637630039667900000","left":"https://cdn.inksoft.com/images/products/2959/products/973M/Royal/sleeveleft/500.png?decache=637630039667900000","right":"https://cdn.inksoft.com/images/products/2959/products/973M/Royal/sleeveright/500.png?decache=637630039667900000","views":"Front, Back, Left, Right","designOnlineUrl":"https://shop.unisourceapparel.com/Unisource_Apparel/shop/design-studio/design?productId=1006590&productStyleId=1082452","sizes":"S, M, L, XL, 2XL"},{"key":"Zuni Sportswear-ZS9006-Royal","category":"Pants","type":"Jogger","brand":"ZUNI Sportswear","mfgSku":"ZS9006","productSku":"ZS9006","productId":"1009869","styleId":"1101183","defaultStyle":false,"colorFamily":"Royal","colorName":"Royal","tone":"Dark","productName":"Premium Jogger Pants","front":"https://cdn.inksoft.com/images/products/2959/products/ZS9006/Royal/front/500.png?decache=638381101986800000","back":"https://cdn.inksoft.com/images/products/2959/products/ZS9006/Royal/back/500.png?decache=638381101986800000","left":"https://cdn.inksoft.com/images/products/2959/products/ZS9006/Royal/sleeveleft/500.png?decache=638381101986800000","right":"https://cdn.inksoft.com/images/products/2959/products/ZS9006/Royal/sleeveright/500.png?decache=638381101986800000","views":"Front, Back, Left, Right","designOnlineUrl":"https://shop.unisourceapparel.com/Unisource_Apparel/shop/design-studio/design?productId=1009869&productStyleId=1101183","sizes":"XS, S, M, L, XL, 2XL, 3XL"},{"key":"Gildan-18200-Navy","category":"Pants","type":"Sweatpants","brand":"Gildan","mfgSku":"18200","productSku":"18200","productId":"1007349","styleId":"1066054","defaultStyle":false,"colorFamily":"Navy","colorName":"Navy","tone":"Dark","productName":"Unisex Heavy Blend™ Sweatpants - 18200 | Gildan","front":"https://cdn.inksoft.com/images/products/2959/products/18200/Navy/front/500.png?decache=638863013578430000","back":"https://cdn.inksoft.com/images/products/2959/products/18200/Navy/back/500.png?decache=638863013578430000","left":"","right":"","views":"Front, Back","designOnlineUrl":"https://shop.unisourceapparel.com/Unisource_Apparel/shop/design-studio/design?productId=1007349&productStyleId=1066054","sizes":"S, M, L, XL, 2XL, 3XL"},{"key":"Jerzees-973M-J Navy","category":"Pants","type":"Sweatpants","brand":"Jerzees","mfgSku":"973M","productSku":"973M","productId":"1006590","styleId":"1059454","defaultStyle":false,"colorFamily":"Navy","colorName":"J Navy","tone":"Dark","productName":"JERZEES NuBlend Sweatpant","front":"https://cdn.inksoft.com/images/products/2959/products/973M/J_Navy/front/500.png?decache=637630039667900000","back":"https://cdn.inksoft.com/images/products/2959/products/973M/J_Navy/back/500.png?decache=637630039667900000","left":"https://cdn.inksoft.com/images/products/2959/products/973M/J_Navy/sleeveleft/500.png?decache=637630039667900000","right":"https://cdn.inksoft.com/images/products/2959/products/973M/J_Navy/sleeveright/500.png?decache=637630039667900000","views":"Front, Back, Left, Right","designOnlineUrl":"https://shop.unisourceapparel.com/Unisource_Apparel/shop/design-studio/design?productId=1006590&productStyleId=1059454","sizes":"S, M, L, XL, 2XL, 3XL"},{"key":"Zuni Sportswear-ZS9006-Navy","category":"Pants","type":"Jogger","brand":"ZUNI Sportswear","mfgSku":"ZS9006","productSku":"ZS9006","productId":"1009869","styleId":"1101173","defaultStyle":false,"colorFamily":"Navy","colorName":"Navy","tone":"Dark","productName":"Premium Jogger Pants","front":"https://cdn.inksoft.com/images/products/2959/products/ZS9006/Navy/front/500.png?decache=638381099948600000","back":"https://cdn.inksoft.com/images/products/2959/products/ZS9006/Navy/back/500.png?decache=638381099948600000","left":"https://cdn.inksoft.com/images/products/2959/products/ZS9006/Navy/sleeveleft/500.png?decache=638381099948600000","right":"https://cdn.inksoft.com/images/products/2959/products/ZS9006/Navy/sleeveright/500.png?decache=638381099948600000","views":"Front, Back, Left, Right","designOnlineUrl":"https://shop.unisourceapparel.com/Unisource_Apparel/shop/design-studio/design?productId=1009869&productStyleId=1101173","sizes":"XS, S, M, L, XL, 2XL, 3XL"}];

  const COLOR_FAMILY_ORDER = ["White", "Black", "Grey", "Royal", "Navy"];

  const DEFAULT_APPAREL =
    CURATED_APPAREL_LIBRARY.find((item) =>
      String(item.productId) === "1010290" &&
      String(item.styleId) === "1106313"
    ) ||
    CURATED_APPAREL_LIBRARY.find((item) =>
      item.category === "Short Sleeve T-Shirt" &&
      item.colorFamily === "White"
    ) ||
    CURATED_APPAREL_LIBRARY.find((item) => item.front) ||
    null;

  const els = {
    loader: document.getElementById("design-inspiration-loader"),
    status: document.getElementById("di-global-status"),
    heroHeadline: document.getElementById("di-hero-headline"),
    heroSubheadline: document.getElementById("di-hero-subheadline"),
    primaryCategories: document.getElementById("di-primary-categories"),
    featuredSection: document.getElementById("di-featured-section"),
    featuredScroller: document.getElementById("di-featured-scroller"),
    featuredPrev: document.getElementById("di-featured-prev"),
    featuredNext: document.getElementById("di-featured-next"),
    allDesigns: document.getElementById("di-all-designs"),
    allDesignsPagination: document.getElementById("di-all-designs-pagination"),
    howItWorks: document.getElementById("di-how-it-works"),
    modal: document.getElementById("di-modal"),
    modalContent: document.getElementById("di-modal-content"),
    modalClose: document.getElementById("di-modal-close"),
  };

  function showLoader() {
    if (els.loader) els.loader.style.display = "flex";
  }

  function hideLoader() {
    if (els.loader) els.loader.style.display = "none";
  }

  function setStatus(message, type = "info") {
    if (!els.status) return;
    els.status.textContent = message;
    els.status.className = `di-status di-status--${type}`;
  }

  async function fetchJson(url) {
    const response = await fetch(url, { cache: "no-store" });
    if (!response.ok) throw new Error(`HTTP ${response.status}: ${url}`);
    return response.json();
  }

  let DESIGN_MATRIX = null;
  let DESIGN_MATRIX_BY_ID = new Map();
  let DESIGN_MATRIX_BY_TITLE = new Map();
  let MATRIX_APPAREL_LIBRARY = [];

  function normalizeMatrixLookupText(value) {
    return String(value || "")
      .toLowerCase()
      .replace(/&amp;/g, "&")
      .replace(/[^a-z0-9]+/g, " ")
      .replace(/\s+/g, " ")
      .trim();
  }

  function getDesignLookupTitles(design) {
    if (!design) return [];

    return [
      design.title,
      design.name,
      design.publicTitle,
      design.public_title,
      design.artworkTitle,
      design.artwork_title,
      design.slug,
    ]
      .filter(Boolean)
      .map(normalizeMatrixLookupText)
      .filter(Boolean);
  }

  function getMatrixLookupTitles(artwork) {
    if (!artwork) return [];

    return [
      artwork.publicTitle,
      artwork.public_title,
      artwork.artworkTitle,
      artwork.artwork_title,
      artwork.title,
      artwork.name,
      artwork.slug,
    ]
      .filter(Boolean)
      .map(normalizeMatrixLookupText)
      .filter(Boolean);
  }

  function normalizeMatrixApparelRecord(record) {
    if (!record) return null;

    const mockups = record.mockups || {};
    const productId = String(record.productId || "");
    const styleId = String(record.styleId || "");
    const colorName = String(record.colorName || "");

    if (!productId || !styleId) return null;

    return {
      key:
        record.key ||
        [
          record.brand || "Apparel",
          record.manufacturerSku || record.productSku || productId,
          colorName || styleId,
        ]
          .filter(Boolean)
          .join("-"),
      category: record.apparelType || record.category || "Apparel",
      type: record.apparelType || record.type || "Apparel",
      brand: record.brand || "",
      mfgSku: record.manufacturerSku || record.mfgSku || "",
      productSku: record.productSku || "",
      productId,
      styleId,
      defaultStyle: Boolean(record.defaultForType || record.defaultStyle),
      colorFamily: record.curatedColorFamily || record.colorFamily || colorName,
      colorName,
      tone: record.garmentTone || record.tone || "",
      productName: record.productName || "",
      front: mockups.Front || record.front || "",
      back: mockups.Back || record.back || "",
      left: mockups.Left || record.left || "",
      right: mockups.Right || record.right || "",
      views: ["Front", "Back", "Left", "Right"]
        .filter((side) => mockups[side] || record[String(side).toLowerCase()])
        .join(", "),
      designOnlineUrl: record.designOnlineUrl || "",
      sizes: Array.isArray(record.availableSizes)
        ? record.availableSizes.join(", ")
        : record.sizes || "",
    };
  }

  function getCombinedApparelLibrary() {
    const records = [...CURATED_APPAREL_LIBRARY];

    MATRIX_APPAREL_LIBRARY.forEach((record) => {
      const exists = records.some(
        (item) =>
          String(item.productId) === String(record.productId) &&
          String(item.styleId) === String(record.styleId) &&
          String(item.colorName || "") === String(record.colorName || "")
      );

      if (!exists) records.push(record);
    });

    return records;
  }

  function buildMatrixIndex(matrix) {
    DESIGN_MATRIX_BY_ID = new Map();
    DESIGN_MATRIX_BY_TITLE = new Map();
    MATRIX_APPAREL_LIBRARY = [];

    if (!matrix || typeof matrix !== "object") return;

    if (Array.isArray(matrix.artworks)) {
      matrix.artworks.forEach((artwork) => {
        const designId = String(
          artwork.designId ||
            artwork.inksoftDesignId ||
            artwork.inksoft_design_id ||
            ""
        ).trim();

        if (designId) {
          DESIGN_MATRIX_BY_ID.set(designId, artwork);
        }

        getMatrixLookupTitles(artwork).forEach((titleKey) => {
          if (titleKey && !DESIGN_MATRIX_BY_TITLE.has(titleKey)) {
            DESIGN_MATRIX_BY_TITLE.set(titleKey, artwork);
          }
        });
      });
    }

    if (Array.isArray(matrix.curatedApparel)) {
      MATRIX_APPAREL_LIBRARY = matrix.curatedApparel
        .map(normalizeMatrixApparelRecord)
        .filter(Boolean);
    }
  }

  async function loadDesignMatrix() {
    const useMatrix = (matrix, sourceLabel) => {
      DESIGN_MATRIX = matrix;
      buildMatrixIndex(matrix);
      console.info(
        `[Design Inspiration] Matrix loaded from ${sourceLabel}:`,
        matrix?.counts || {
          artworks: Array.isArray(matrix?.artworks) ? matrix.artworks.length : 0,
          curatedApparel: Array.isArray(matrix?.curatedApparel)
            ? matrix.curatedApparel.length
            : 0,
        },
        {
          matrixUrl: DI_MATRIX_URL,
          indexedDesignIds: DESIGN_MATRIX_BY_ID.size,
          indexedTitles: DESIGN_MATRIX_BY_TITLE.size,
          barackObamaPosition:
            DESIGN_MATRIX_BY_ID.get("1752537")?.sides?.Front?.position || null,
        }
      );
      return matrix;
    };

    if (!DI_MATRIX_URL) {
      console.warn(
        "[Design Inspiration] Matrix URL is blank. Matrix rules will not be applied."
      );
      DESIGN_MATRIX = null;
      DESIGN_MATRIX_BY_ID = new Map();
      DESIGN_MATRIX_BY_TITLE = new Map();
      MATRIX_APPAREL_LIBRARY = [];
      return null;
    }

    try {
      const matrix = await fetchJson(DI_MATRIX_URL);
      return useMatrix(matrix, "external JSON");
    } catch (error) {
      console.warn(
        "[Design Inspiration] Matrix JSON could not be loaded. Matrix rules will not be applied:",
        error
      );

      DESIGN_MATRIX = null;
      DESIGN_MATRIX_BY_ID = new Map();
      DESIGN_MATRIX_BY_TITLE = new Map();
      MATRIX_APPAREL_LIBRARY = [];
      return null;
    }
  }

  function escapeHtml(value) {
    return String(value || "")
      .replace(/&/g, "&amp;")
      .replace(/</g, "&lt;")
      .replace(/>/g, "&gt;")
      .replace(/"/g, "&quot;");
  }

  function normalizeImage(url) {
    if (!url) return "";

    const raw = String(url).trim();
    if (!raw) return "";

    if (raw.startsWith("http://") || raw.startsWith("https://")) return raw;

    if (raw.startsWith("/Unisource_Apparel/")) {
      return `https://shop.unisourceapparel.com${raw}`;
    }

    if (raw.startsWith("/images/")) {
      return `https://shop.unisourceapparel.com/Unisource_Apparel${raw}`;
    }

    if (raw.startsWith("Unisource_Apparel/")) {
      return `https://shop.unisourceapparel.com/${raw}`;
    }

    return `https://shop.unisourceapparel.com/${raw.replace(/^\/+/, "")}`;
  }

  function extractDesignId(design) {
    if (design.inksoftDesignId) return String(design.inksoftDesignId);

    const sources = [
      design.id,
      design.slug,
      design.thumbnailUrl,
      design.previewImageUrl,
      design.imageUrl,
      Array.isArray(design.canvases) && design.canvases[0]
        ? design.canvases[0].thumbnailUrl
        : "",
      Array.isArray(design.canvases) && design.canvases[0]
        ? design.canvases[0].imageUrl
        : "",
    ];

    for (const src of sources) {
      const value = String(src || "");

      let match = value.match(/DI-(\d+)/i);
      if (match && match[1]) return match[1];

      match = value.match(/designs\/(\d+)\./i);
      if (match && match[1]) return match[1];

      match = value.match(/2959-(\d+)/i);
      if (match && match[1]) return match[1];

      match = value.match(/-(\d{6,})$/i);
      if (match && match[1]) return match[1];
    }

    return "";
  }

  function getMatrixArtworkForDesign(design) {
    if (!design) return null;

    const hasIdIndex = DESIGN_MATRIX_BY_ID && DESIGN_MATRIX_BY_ID.size;
    const hasTitleIndex = DESIGN_MATRIX_BY_TITLE && DESIGN_MATRIX_BY_TITLE.size;

    if (!hasIdIndex && !hasTitleIndex) return null;

    const designId = extractDesignId(design);
    if (designId && DESIGN_MATRIX_BY_ID.has(String(designId))) {
      return DESIGN_MATRIX_BY_ID.get(String(designId));
    }

    const directId = String(
      design.inksoftDesignId ||
        design.inksoft_design_id ||
        design.designId ||
        design.id ||
        ""
    ).trim();

    if (directId && DESIGN_MATRIX_BY_ID.has(directId)) {
      return DESIGN_MATRIX_BY_ID.get(directId);
    }

    const titleKeys = getDesignLookupTitles(design);

    for (const titleKey of titleKeys) {
      if (DESIGN_MATRIX_BY_TITLE.has(titleKey)) {
        return DESIGN_MATRIX_BY_TITLE.get(titleKey);
      }
    }

    return null;
  }

  function normalizeMatrixSideRecord(record, side) {
    if (!record) return null;

    return {
      side: side || normalizeSideName(record.side),
      displaySide: Boolean(record.displaySide),
      sideArtworkSource: record.sideArtworkSource || "Auto InkSoft",
      artworkUrlOverride: record.artworkUrlOverride || "",
      mockupUrlOverride: record.mockupUrlOverride || "",
      placementLabel: record.placementLabel || record.placementPreset || side || "",
      placementPreset: record.placementPreset || "",

      /* v46 naming convention. JSON is the source of positioning. */
      artworkPositionModal:
        record.artworkPositionModal || record.position || record.placementOverride || {},
      artworkPositionGrid:
        record.artworkPositionGrid ||
        record.artworkPositionModal ||
        record.position ||
        record.placementOverride ||
        {},
      apparelPositionModal:
        record.apparelPositionModal ||
        record.apparelPosition ||
        record.mockupPosition ||
        record.garmentPosition ||
        {},
      apparelPositionGrid:
        record.apparelPositionGrid ||
        record.apparelPositionModal ||
        record.apparelPosition ||
        record.mockupPosition ||
        record.garmentPosition ||
        {},

      /* Legacy fields retained only for backward compatibility. */
      placementOverride: record.placementOverride || {},
      position: record.position || {},
      placementReady: Boolean(record.placementReady),
      notes: record.notes || "",
    };
  }

  function getMatrixSidesForDesign(design) {
    const matrixArtwork = getMatrixArtworkForDesign(design);
    if (!matrixArtwork || !matrixArtwork.sides) return null;

    const result = {};

    ["Front", "Back", "Left", "Right"].forEach((side) => {
      const record = matrixArtwork.sides[side];
      if (record) {
        result[side] = normalizeMatrixSideRecord(record, side);
      }
    });

    return result;
  }

  function getMatrixSideForDesign(design, side) {
    const sides = getMatrixSidesForDesign(design);
    const normalizedSide = normalizeSideName(side);

    return sides && sides[normalizedSide] ? sides[normalizedSide] : null;
  }

  function getMatrixPlacementPresetDefaults(presetName) {
    const name = String(presetName || "").trim();

    if (!name || !DESIGN_MATRIX || !DESIGN_MATRIX.placementPresets) {
      return {};
    }

    return DESIGN_MATRIX.placementPresets[name] || {};
  }

  function hasPositionValue(value) {
    return value !== null && value !== undefined && value !== "";
  }

  function firstPositionValue(...values) {
    for (const value of values) {
      if (hasPositionValue(value)) return value;
    }
    return undefined;
  }

  function normalizeArtworkPositionObject(source) {
    const item = source || {};

    return {
      topPercent: firstPositionValue(item.topPercent, item.artworkYPercent),
      leftPercent: firstPositionValue(item.leftPercent, item.artworkXPercent),
      artworkWidthPercent: firstPositionValue(item.artworkWidthPercent, item.widthPercent),
      maxWidthPx: firstPositionValue(item.maxWidthPx, item.artworkMaxWidthPx),
      maxHeightPx: firstPositionValue(item.maxHeightPx, item.artworkMaxHeightPx),
      translateXPercent: firstPositionValue(item.translateXPercent, item.translateX, -50),
      translateYPercent: firstPositionValue(item.translateYPercent, item.translateY, -50),
      rotationDeg: firstPositionValue(item.rotationDeg, 0),
    };
  }

  function normalizeApparelPositionObject(source) {
    const item = source || {};

    return {
      topPercent: firstPositionValue(item.topPercent, item.apparelTopPercent, item.mockupTopPercent),
      leftPercent: firstPositionValue(item.leftPercent, item.apparelLeftPercent, item.mockupLeftPercent),
      widthPercent: firstPositionValue(item.widthPercent, item.apparelWidthPercent, item.mockupWidthPercent),
      heightPercent: firstPositionValue(item.heightPercent, item.apparelHeightPercent, item.mockupHeightPercent),
      maxWidthPx: firstPositionValue(item.maxWidthPx, item.apparelMaxWidthPx, item.mockupMaxWidthPx),
      maxHeightPx: firstPositionValue(item.maxHeightPx, item.apparelMaxHeightPx, item.mockupMaxHeightPx),
      translateXPercent: firstPositionValue(item.translateXPercent, item.translateX),
      translateYPercent: firstPositionValue(item.translateYPercent, item.translateY),
      scale: firstPositionValue(item.scale),
      rotationDeg: firstPositionValue(item.rotationDeg, 0),
    };
  }

  function mergePositionObjects(...sources) {
    const result = {};

    sources.forEach((source) => {
      if (!source) return;
      Object.keys(source).forEach((key) => {
        if (!hasPositionValue(result[key]) && hasPositionValue(source[key])) {
          result[key] = source[key];
        }
      });
    });

    return result;
  }

  function getFallbackPreset(name) {
    return DESIGN_MATRIX?.fallbackPresets?.[name] || {};
  }

  function getFallbackPresetBySide(name, side) {
    const normalizedSide = normalizeSideName(side);
    return DESIGN_MATRIX?.fallbackPresets?.[name]?.[normalizedSide] || {};
  }

  function getMatrixPlacementPresetPosition(presetName, viewMode) {
    const preset = getMatrixPlacementPresetDefaults(presetName);
    const modeKey = viewMode === "Grid" ? "artworkPositionGrid" : "artworkPositionModal";
    const otherModeKey = viewMode === "Grid" ? "artworkPositionModal" : "artworkPositionGrid";

    return normalizeArtworkPositionObject(
      preset[modeKey] || preset[otherModeKey] || preset
    );
  }

  function getApparelPositionPreset(apparelRecord, side, viewMode) {
    const presets = DESIGN_MATRIX?.apparelPositionPresets || {};
    if (!apparelRecord || !presets) return {};

    const normalizedSide = normalizeSideName(side);
    const modeKey = viewMode === "Grid" ? "apparelPositionGrid" : "apparelPositionModal";
    const multiModeKey = viewMode === "Grid" ? "apparelPositionGridMultiSide" : "apparelPositionModalMultiSide";

    const candidateKeys = uniqueList([
      apparelRecord.category,
      apparelRecord.type,
      apparelRecord.mfgSku,
      apparelRecord.productSku,
      apparelRecord.productId,
      apparelRecord.key,
    ].filter(Boolean).map((item) => String(item)));

    for (const key of candidateKeys) {
      const entry = presets[key];
      if (!entry) continue;

      const sideEntry = entry[normalizedSide] || entry.Default || entry.default || entry;
      const resolved =
        sideEntry[multiModeKey] ||
        sideEntry[modeKey] ||
        sideEntry.apparelPositionModal ||
        sideEntry.apparelPositionGrid ||
        sideEntry;

      if (resolved && Object.keys(resolved).length) {
        return normalizeApparelPositionObject(resolved);
      }
    }

    return {};
  }

  function buildArtworkPositionStyle(position) {
    const styles = [];

    if (hasPositionValue(position.leftPercent)) {
      styles.push(`left: ${Number(position.leftPercent)}% !important`);
    }

    if (hasPositionValue(position.topPercent)) {
      styles.push(`top: ${Number(position.topPercent)}% !important`);
    }

    if (hasPositionValue(position.artworkWidthPercent)) {
      styles.push(`width: ${Number(position.artworkWidthPercent)}% !important`);
    }

    if (hasPositionValue(position.maxWidthPx)) {
      styles.push(`max-width: ${Number(position.maxWidthPx)}px !important`);
    }

    if (hasPositionValue(position.maxHeightPx)) {
      styles.push(`max-height: ${Number(position.maxHeightPx)}px !important`);
    }

    const translateX = firstPositionValue(position.translateXPercent, -50);
    const translateY = firstPositionValue(position.translateYPercent, -50);
    const rotation = firstPositionValue(position.rotationDeg, 0);

    styles.push(
      `transform: translate(${Number(translateX)}%, ${Number(translateY)}%) rotate(${Number(rotation) || 0}deg) !important`
    );

    return styles.length ? styles.join("; ") + ";" : "";
  }

  function buildApparelPositionStyle(position) {
    const styles = [];

    styles.push("position: absolute !important");

    if (hasPositionValue(position.leftPercent)) {
      styles.push(`left: ${Number(position.leftPercent)}% !important`);
    }

    if (hasPositionValue(position.topPercent)) {
      styles.push(`top: ${Number(position.topPercent)}% !important`);
    }

    if (hasPositionValue(position.widthPercent)) {
      styles.push(`width: ${Number(position.widthPercent)}% !important`);
    }

    if (hasPositionValue(position.heightPercent)) {
      styles.push(`height: ${Number(position.heightPercent)}% !important`);
    } else {
      styles.push("height: auto !important");
    }

    if (hasPositionValue(position.maxWidthPx)) {
      styles.push(`max-width: ${Number(position.maxWidthPx)}px !important`);
    }

    if (hasPositionValue(position.maxHeightPx)) {
      styles.push(`max-height: ${Number(position.maxHeightPx)}px !important`);
    }

    const transformParts = [];

    if (hasPositionValue(position.translateXPercent) || hasPositionValue(position.translateYPercent)) {
      transformParts.push(
        `translate(${Number(firstPositionValue(position.translateXPercent, 0))}%, ${Number(firstPositionValue(position.translateYPercent, 0))}%)`
      );
    }

    if (hasPositionValue(position.scale)) {
      transformParts.push(`scale(${Number(position.scale)})`);
    }

    if (hasPositionValue(position.rotationDeg) && Number(position.rotationDeg)) {
      transformParts.push(`rotate(${Number(position.rotationDeg)}deg)`);
    }

    if (transformParts.length) {
      styles.push(`transform: ${transformParts.join(" ")} !important`);
      styles.push("transform-origin: center center !important");
    }

    return styles.length ? styles.join("; ") + ";" : "";
  }

  function normalizeExplicitArtworkOverride(source) {
    if (!source || typeof source !== "object") return null;

    const result = {};
    const mappings = {
      topPercent: ["topPercent", "artworkYPercent"],
      leftPercent: ["leftPercent", "artworkXPercent"],
      artworkWidthPercent: ["artworkWidthPercent", "widthPercent"],
      maxWidthPx: ["maxWidthPx", "artworkMaxWidthPx"],
      maxHeightPx: ["maxHeightPx", "artworkMaxHeightPx"],
      translateXPercent: ["translateXPercent", "translateX"],
      translateYPercent: ["translateYPercent", "translateY"],
      rotationDeg: ["rotationDeg"],
    };

    Object.entries(mappings).forEach(([target, keys]) => {
      for (const key of keys) {
        if (Object.prototype.hasOwnProperty.call(source, key) && hasPositionValue(source[key])) {
          result[target] = source[key];
          break;
        }
      }
    });

    return Object.keys(result).length ? result : null;
  }

  function normalizeExplicitApparelOverride(source) {
    if (!source || typeof source !== "object") return null;

    const result = {};
    const mappings = {
      topPercent: ["topPercent", "apparelTopPercent", "mockupTopPercent"],
      leftPercent: ["leftPercent", "apparelLeftPercent", "mockupLeftPercent"],
      widthPercent: ["widthPercent", "apparelWidthPercent", "mockupWidthPercent"],
      heightPercent: ["heightPercent", "apparelHeightPercent", "mockupHeightPercent"],
      maxWidthPx: ["maxWidthPx", "apparelMaxWidthPx", "mockupMaxWidthPx"],
      maxHeightPx: ["maxHeightPx", "apparelMaxHeightPx", "mockupMaxHeightPx"],
      translateXPercent: ["translateXPercent", "translateX"],
      translateYPercent: ["translateYPercent", "translateY"],
      scale: ["scale"],
      rotationDeg: ["rotationDeg"],
    };

    Object.entries(mappings).forEach(([target, keys]) => {
      for (const key of keys) {
        if (Object.prototype.hasOwnProperty.call(source, key) && hasPositionValue(source[key])) {
          result[target] = source[key];
          break;
        }
      }
    });

    return Object.keys(result).length ? result : null;
  }

  function getVisualizerProductOverrideSource(matrixArtwork, apparelRecord, side, modeKey) {
    if (!matrixArtwork || !apparelRecord) return null;

    const productId = String(apparelRecord.productId || "");
    const styleId = String(apparelRecord.styleId || "");
    if (!productId) return null;

    const products = matrixArtwork?.visualizerControls?.productOverrides;
    const productBucket = products?.[productId];
    if (!productBucket) return null;

    const styles = productBucket.styles || {};
    const styleBucket =
      (styleId && styles[styleId]) ||
      styles._default ||
      styles.default ||
      null;

    const sideBucket = styleBucket?.sides?.[side];
    if (!sideBucket) return null;

    return sideBucket?.[modeKey] || null;
  }

  function getArtworkPositionOverride(matrixArtwork, apparelRecord, side, viewMode) {
    const modeKey = viewMode === "Grid" ? "artworkPositionGrid" : "artworkPositionModal";

    return normalizeExplicitArtworkOverride(
      getVisualizerProductOverrideSource(
        matrixArtwork,
        apparelRecord,
        side,
        modeKey
      )
    );
  }

  function getApparelPositionOverrideSource(source, apparelRecord, side, modeKey) {
    if (!source || !apparelRecord) return null;

    const productId = String(apparelRecord.productId || "");
    const styleId = String(apparelRecord.styleId || "");
    if (!productId) return null;

    const productBucket = source[productId];
    if (!productBucket) return null;

    const styleBucket =
      (styleId && productBucket[styleId]) ||
      productBucket._default ||
      productBucket.default ||
      null;

    const sideBucket = styleBucket?.[side];
    if (!sideBucket) return null;

    return normalizeApparelPositionObject(sideBucket?.[modeKey]);
  }

  function getApparelPositionOverride(matrixArtwork, apparelRecord, side, viewMode) {
    const modeKey = viewMode === "Grid" ? "apparelPositionGrid" : "apparelPositionModal";

    return mergePositionObjects(
      normalizeExplicitApparelOverride(
        getVisualizerProductOverrideSource(
          matrixArtwork,
          apparelRecord,
          side,
          modeKey
        )
      ),
      getApparelPositionOverrideSource(matrixArtwork?.apparelPositionOverrides, apparelRecord, side, modeKey),
      getApparelPositionOverrideSource(DESIGN_MATRIX?.apparelPositionOverrides, apparelRecord, side, modeKey)
    );
  }

  function getMatrixApparelPositionStyle(design, side, viewMode = "Modal", apparelRecord = null) {
    const matrixArtwork = getMatrixArtworkForDesign(design);
    const matrixSide = getMatrixSideForDesign(design, side);
    const modeKey = viewMode === "Grid" ? "apparelPositionGrid" : "apparelPositionModal";
    const fallbackKey = viewMode === "Grid" ? "defaultApparelPositionGrid" : "defaultApparelPositionModal";
    const fallbackSideKey = viewMode === "Grid" ? "defaultApparelPositionGridBySide" : "defaultApparelPositionModalBySide";

    /*
       v57:
       Additional apparel can now have its own display positioning.

       Registered artwork priority:
       1. artwork.apparelPositionOverrides[productId][styleId][side]
       2. artwork.apparelPositionOverrides[productId]._default[side]
       3. DESIGN_MATRIX.apparelPositionOverrides[productId][styleId][side]
       4. DESIGN_MATRIX.apparelPositionOverrides[productId]._default[side]
       5. side.apparelPositionModal OR side.apparelPositionGrid
       6. apparelPositionPresets for the active apparel type and side
       7. fallbackPresets

       This preserves current side-level controls, but lets an added hoodie,
       crewneck, polo, or other product have its own modal/grid display tuning.
    */
    const position = matrixArtwork
      ? mergePositionObjects(
          getApparelPositionOverride(matrixArtwork, apparelRecord, side, viewMode),
          normalizeApparelPositionObject(matrixSide?.[modeKey]),
          getApparelPositionPreset(apparelRecord, side, viewMode),
          normalizeApparelPositionObject(getFallbackPresetBySide(fallbackSideKey, side)),
          normalizeApparelPositionObject(getFallbackPreset(fallbackKey))
        )
      : mergePositionObjects(
          normalizeApparelPositionObject(getFallbackPresetBySide(fallbackSideKey, side)),
          normalizeApparelPositionObject(getFallbackPreset(fallbackKey)),
          getApparelPositionPreset(apparelRecord, side, viewMode)
        );

    return buildApparelPositionStyle(position);
  }

  function getMatrixPlacementStyle(design, side, viewMode = "Modal", apparelRecord = null) {
    const matrixArtwork = getMatrixArtworkForDesign(design);
    const matrixSide = getMatrixSideForDesign(design, side);
    const modeKey = viewMode === "Grid" ? "artworkPositionGrid" : "artworkPositionModal";
    const otherModeKey = viewMode === "Grid" ? "artworkPositionModal" : "artworkPositionGrid";
    const fallbackKey = viewMode === "Grid" ? "defaultArtworkPositionGrid" : "defaultArtworkPositionModal";
    const fallbackSideKey = viewMode === "Grid" ? "defaultArtworkPositionGridBySide" : "defaultArtworkPositionModalBySide";
    const presetName = matrixSide?.placementPreset || matrixSide?.placementLabel || "Full Front";

    /*
       v48:
       Registered JSON artwork keeps the normal priority:
       side override → placement preset → fallback.

       Unregistered / unmapped InkSoft artwork now uses fallbackPresets first.
       This means editing:
         fallbackPresets.defaultArtworkPositionGrid
       will affect grid cards that are not yet in artworks[].
    */
    const position = matrixArtwork
      ? mergePositionObjects(
          getArtworkPositionOverride(matrixArtwork, apparelRecord, side, viewMode),
          normalizeArtworkPositionObject(matrixSide?.[modeKey]),
          normalizeArtworkPositionObject(matrixSide?.[otherModeKey]),
          normalizeArtworkPositionObject(matrixSide?.position),
          normalizeArtworkPositionObject(matrixSide?.placementOverride),
          getMatrixPlacementPresetPosition(presetName, viewMode),
          normalizeArtworkPositionObject(getFallbackPresetBySide(fallbackSideKey, side)),
          normalizeArtworkPositionObject(getFallbackPreset(fallbackKey))
        )
      : mergePositionObjects(
          normalizeArtworkPositionObject(getFallbackPresetBySide(fallbackSideKey, side)),
          normalizeArtworkPositionObject(getFallbackPreset(fallbackKey)),
          getMatrixPlacementPresetPosition(presetName, viewMode)
        );

    return buildArtworkPositionStyle(position);
  }

  function applyMatrixToDesign(design) {
    if (!design) return design;

    const matrixArtwork = getMatrixArtworkForDesign(design);
    if (!matrixArtwork) return design;

    const merged = {
      ...design,
      matrixArtwork,
      defaultProductId:
        matrixArtwork.defaultApparel?.productId ||
        design.defaultProductId ||
        design.default_product_id,
      default_product_id:
        matrixArtwork.defaultApparel?.productId ||
        design.default_product_id ||
        design.defaultProductId,
      defaultStyleId:
        matrixArtwork.defaultApparel?.styleId ||
        design.defaultStyleId ||
        design.default_style_id,
      default_style_id:
        matrixArtwork.defaultApparel?.styleId ||
        design.default_style_id ||
        design.defaultStyleId,
      defaultColor:
        matrixArtwork.defaultApparel?.color ||
        design.defaultColor ||
        design.default_color,
      default_color:
        matrixArtwork.defaultApparel?.color ||
        design.default_color ||
        design.defaultColor,
    };

    const allowedProductIds = new Set();

    Object.values(matrixArtwork.allowedApparel || {}).forEach((item) => {
      (item.productIds || []).forEach((productId) => {
        if (productId) allowedProductIds.add(String(productId));
      });
    });

    if (matrixArtwork.defaultApparel?.productId) {
      allowedProductIds.add(String(matrixArtwork.defaultApparel.productId));
    }

    if (allowedProductIds.size) {
      merged.allowedProductIds = Array.from(allowedProductIds);
      merged.allowed_product_ids = Array.from(allowedProductIds);
    }

    const sides = matrixArtwork.sides || {};
    const artworkViews = ["Front", "Back", "Left", "Right"]
      .map((side) => sides[side])
      .filter((sideRecord) => sideRecord && sideRecord.displaySide)
      .map((sideRecord) => {
        const side = normalizeSideName(sideRecord.side);
        return {
          side,
          label: sideRecord.placementLabel || sideRecord.placementPreset || side,
          artworkUrl: sideRecord.artworkUrlOverride || "",
          imageUrl: sideRecord.artworkUrlOverride || "",
          url: sideRecord.artworkUrlOverride || "",
          matrixSide: sideRecord,
        };
      });

    if (artworkViews.length) {
      merged.artworkViews = artworkViews;
    }

    return merged;
  }

  function getPublisherArtwork(design) {
    const designId = extractDesignId(design);
    if (!designId) return "";

    return `https://cdn.inksoft.com/images/publishers/2959/designs/${designId}.front.480.png`;
  }

  function getThumbnailArtwork(design) {
    const thumbnail = normalizeImage(design.thumbnailUrl);

    const canvasThumb =
      Array.isArray(design.canvases) && design.canvases.length
        ? normalizeImage(design.canvases[0].thumbnailUrl)
        : "";

    return thumbnail || canvasThumb;
  }

  function getBestArtwork(design) {
    return getPublisherArtwork(design) || getThumbnailArtwork(design);
  }

  function buildArtworkImage(design, className) {
    const artwork = getBestArtwork(design);
    const fallback = getThumbnailArtwork(design);

    if (!artwork && !fallback) {
      return `<div class="di-product-mockup__placeholder">No Artwork</div>`;
    }

    return `
      <img
        class="${escapeHtml(className)}"
        src="${escapeHtml(artwork || fallback)}"
        alt="${escapeHtml(design.title)} artwork"
        loading="lazy"
        data-fallback-src="${escapeHtml(fallback)}"
        onerror="
          if (this.dataset.fallbackSrc && this.src !== this.dataset.fallbackSrc) {
            this.src = this.dataset.fallbackSrc;
          } else {
            this.style.display = 'none';
          }
        "
      >
    `;
  }


  function normalizeSideName(value) {
    const raw = String(value || "")
      .trim()
      .toLowerCase()
      .replace(/[_-]+/g, " ")
      .replace(/\s+/g, " ");

    if (!raw) return "Front";
    if (raw.includes("back")) return "Back";
    if (raw.includes("right")) return "Right";
    if (raw.includes("left")) return "Left";
    if (raw.includes("front")) return "Front";

    return "Front";
  }

  function getArtworkUrlFromCanvas(canvas) {
    if (!canvas) return "";

    return normalizeImage(
      canvas.svgUrl ||
      canvas.transparentSvgUrl ||
      canvas.transparentImageUrl ||
      canvas.transparentUrl ||
      canvas.imageUrl ||
      canvas.thumbnailUrl ||
      canvas.previewImageUrl ||
      canvas.url ||
      ""
    );
  }

  function getCanvasFallbackUrl(canvas, side) {
    if (!canvas) return "";

    return normalizeImage(
      canvas.imageUrl ||
      canvas.thumbnailUrl ||
      canvas.previewImageUrl ||
      canvas.url ||
      ""
    );
  }

  function inferSideFromUrl(url) {
    const value = String(url || "").toLowerCase();

    if (value.includes(".back.") || value.includes("/back/")) return "Back";
    if (
      value.includes(".right.") ||
      value.includes("right_sleeve") ||
      value.includes("sleeve_right") ||
      value.includes("/sleeveright/")
    ) {
      return "Right";
    }
    if (
      value.includes(".left.") ||
      value.includes("left_sleeve") ||
      value.includes("sleeve_left") ||
      value.includes("/sleeveleft/")
    ) {
      return "Left";
    }

    return "Front";
  }

  function uniqueList(values) {
    return Array.from(
      new Set(
        (values || [])
          .map((value) => String(value || "").trim())
          .filter(Boolean)
      )
    );
  }

  function uniqueImageList(values) {
    const seen = new Set();

    return values
      .map((value) => normalizeImage(value))
      .filter((value) => {
        if (!value || seen.has(value)) return false;
        seen.add(value);
        return true;
      });
  }

  function getSidePublisherArtworkCandidates(design, side) {
    const designId = extractDesignId(design);
    if (!designId) return [];

    const normalizedSide = normalizeSideName(side);
    const base = `https://cdn.inksoft.com/images/publishers/2959/designs/${designId}`;

    if (normalizedSide === "Back") {
      return uniqueImageList([
        `${base}.back.480.png`,
        `${base}.Back.480.png`,
      ]);
    }

    if (normalizedSide === "Left") {
      return uniqueImageList([
        `${base}.left.480.png`,
        `${base}.sleeveleft.480.png`,
        `${base}.leftsleeve.480.png`,
        `${base}.left-sleeve.480.png`,
        `${base}.sleeve-left.480.png`,
      ]);
    }

    if (normalizedSide === "Right") {
      return uniqueImageList([
        `${base}.right.480.png`,
        `${base}.sleeveright.480.png`,
        `${base}.rightsleeve.480.png`,
        `${base}.right-sleeve.480.png`,
        `${base}.sleeve-right.480.png`,
      ]);
    }

    return uniqueImageList([
      `${base}.front.480.png`,
      `${base}.Front.480.png`,
    ]);
  }

  function getSidePublisherArtwork(design, side) {
    return getSidePublisherArtworkCandidates(design, side)[0] || "";
  }

  function getDesignArtworkViews(design) {
    const views = [];
    const seen = new Set();
    const matrixArtwork = getMatrixArtworkForDesign(design);

    const addView = (side, artworkUrl, label, fallbackUrl = "", options = {}) => {
      const normalizedSide = normalizeSideName(side);
      const allowPublisherFallback = Boolean(options.allowPublisherFallback);
      const sidePublisherCandidates = allowPublisherFallback
        ? getSidePublisherArtworkCandidates(design, normalizedSide)
        : [];
      const fallbackCandidates = Array.isArray(fallbackUrl) ? fallbackUrl : [fallbackUrl];
      const candidates = uniqueImageList([
        artworkUrl,
        ...sidePublisherCandidates,
        ...fallbackCandidates,
      ]);
      const url = candidates[0] || "";
      const fallbackUrls = candidates.slice(1);

      if (!url || seen.has(normalizedSide)) return;

      seen.add(normalizedSide);
      views.push({
        side: normalizedSide,
        artworkUrl: url,
        fallbackUrl: fallbackUrls[0] || "",
        fallbackUrls,
        label: label || normalizedSide,
      });
    };

    /*
      v51:
      JSON is now the source of truth for multi-side Visualizer display.

      Rule:
      - If artwork IS mapped in the JSON matrix, only sides marked as displayable
        there should appear in the Visualizer.
      - If artwork is NOT mapped in the JSON matrix, assume it is a single-side
        design and show FRONT only.

      This prevents unmapped InkSoft designs from auto-showing Back / Left / Right
      views just because publisher image URLs can be guessed.
    */
    if (matrixArtwork && matrixArtwork.sides) {
      ["Front", "Back", "Left", "Right"].forEach((side) => {
        const sideRecord = matrixArtwork.sides[side];
        if (!sideRecord) return;
        if (!sideRecord.displaySide) return;
        if (sideRecord.showInVisualizer === false) return;

        const normalizedSide = normalizeSideName(sideRecord.side || side);
        const explicitArtwork =
          sideRecord.artworkUrlOverride ||
          design[`${normalizedSide.toLowerCase()}ArtworkUrl`] ||
          design[`${normalizedSide.toLowerCase()}_artwork_url`] ||
          "";

        addView(
          normalizedSide,
          explicitArtwork,
          sideRecord.placementLabel || sideRecord.placementPreset || normalizedSide,
          explicitArtwork,
          { allowPublisherFallback: true }
        );
      });
    }

    if (!views.length) {
      const frontArtwork =
        getPublisherArtwork(design) ||
        getSidePublisherArtwork(design, "Front") ||
        getThumbnailArtwork(design) ||
        normalizeImage(design.frontArtworkUrl) ||
        normalizeImage(design.front_artwork_url) ||
        normalizeImage(design.previewImageUrl) ||
        normalizeImage(design.imageUrl);

      addView("Front", frontArtwork, "Front", "", { allowPublisherFallback: true });
    }

    const order = { Front: 1, Back: 2, Left: 3, Right: 4 };

    return views.sort((a, b) => (order[a.side] || 99) - (order[b.side] || 99));
  }


  function getMockupUrlForSide(apparel, side) {
    if (!apparel) return "";

    if (side === "Back") return apparel.back || apparel.front || "";
    if (side === "Left") return apparel.left || apparel.front || "";
    if (side === "Right") return apparel.right || apparel.front || "";

    return apparel.front || "";
  }

  function getDefaultUnmappedApparelRecord() {
    const library = getCombinedApparelLibrary();

    return (
      library.find((item) =>
        String(item.productId) === "1010290" &&
        String(item.styleId) === "1106313" &&
        (String(item.colorName || "").toLowerCase() === "white" ||
          String(item.colorFamily || "").toLowerCase() === "white")
      ) ||
      library.find((item) =>
        String(item.productId) === "1010290" &&
        String(item.styleId) === "1106313"
      ) ||
      library.find((item) =>
        item.category === "Short Sleeve T-Shirt" && item.colorFamily === "White"
      ) ||
      DEFAULT_APPAREL
    );
  }

  function normalizeFilterText(value) {
    return String(value || "")
      .trim()
      .toLowerCase()
      .replace(/[\s_\-]+/g, " ");
  }

  function recordMatchesAllowedColor(record, colors) {
    if (!Array.isArray(colors) || !colors.length) return true;

    const allowedColors = colors
      .map((color) => normalizeFilterText(color))
      .filter(Boolean);

    if (!allowedColors.length) return true;

    const recordColorNames = [
      record.colorName,
      record.colorFamily,
      record.curatedColorFamily,
      record.tone,
    ]
      .map((value) => normalizeFilterText(value))
      .filter(Boolean);

    return allowedColors.some((allowed) => recordColorNames.includes(allowed));
  }

  function buildAllowedApparelRules(matrixArtwork) {
    const rules = [];

    Object.entries(matrixArtwork?.allowedApparel || {}).forEach(([category, rule]) => {
      const productIds = Array.isArray(rule?.productIds)
        ? rule.productIds.map((value) => String(value)).filter(Boolean)
        : [];

      const colors = Array.isArray(rule?.colors)
        ? rule.colors.map((value) => String(value)).filter(Boolean)
        : [];

      rules.push({
        category,
        productIds,
        colors,
      });
    });

    const defaultApparel = matrixArtwork?.defaultApparel || {};
    if (defaultApparel.productId || defaultApparel.color || defaultApparel.apparelType) {
      const category = defaultApparel.apparelType || "";
      let rule = rules.find((item) => item.category === category);

      if (!rule) {
        rule = {
          category,
          productIds: [],
          colors: [],
        };
        rules.push(rule);
      }

      if (defaultApparel.productId && !rule.productIds.includes(String(defaultApparel.productId))) {
        rule.productIds.push(String(defaultApparel.productId));
      }

      if (defaultApparel.color && !rule.colors.includes(String(defaultApparel.color))) {
        rule.colors.push(String(defaultApparel.color));
      }
    }

    return rules;
  }

  function recordMatchesAllowedApparelRule(record, rule) {
    if (!record || !rule) return false;

    const categoryMatches = !rule.category || record.category === rule.category;
    const productMatches =
      !Array.isArray(rule.productIds) ||
      !rule.productIds.length ||
      rule.productIds.includes(String(record.productId));

    return (
      categoryMatches &&
      productMatches &&
      recordMatchesAllowedColor(record, rule.colors)
    );
  }

  function getAvailableApparelRecords(design) {
    const library = getCombinedApparelLibrary();
    const matrixArtwork = getMatrixArtworkForDesign(design);

    /*
      v52:
      Default / unmapped artwork should open with a clean Visualizer state.
      Rule for unmapped artwork:
      - Apparel Type: Short Sleeve T-Shirt only
      - Product: Gildan 5000 / Product ID 1010290
      - Style: 1106313
      - Color: White

      If more apparel types / colors are needed, they should be explicitly
      configured in the JSON matrix for that artwork.
    */
    if (!matrixArtwork) {
      const defaultRecord = getDefaultUnmappedApparelRecord();
      return defaultRecord ? [defaultRecord] : [DEFAULT_APPAREL];
    }

    /*
      v56:
      allowedApparel.colors is now enforced.

      The Visualizer no longer shows every color under an allowed Product ID.
      It now filters by:
      1. apparel type / category
      2. productId
      3. colorName / colorFamily / curatedColorFamily

      defaultApparel is automatically included so the default opening product/color
      remains available even when it is not repeated inside allowedApparel.
    */
    const allowedRules = buildAllowedApparelRules(matrixArtwork);

    if (allowedRules.length) {
      const filtered = library.filter((record) =>
        allowedRules.some((rule) => recordMatchesAllowedApparelRule(record, rule))
      );

      if (filtered.length) return filtered;
    }

    const explicitProductIds = [
      design.defaultProductId,
      design.default_product_id,
      design.short_sleeve_tshirt_product_id,
      design.long_sleeve_tshirt_product_id,
      design.pullover_sweatshirt_product_id,
      design.crewneck_sweatshirt_product_id,
      design.zipped_sweatshirt_product_id,
      design.polo_product_id,
      design.shorts_product_id,
      design.pants_product_id,
      design.tote_bag_product_id,
      design.cinch_bag_product_id,
    ]
      .filter(Boolean)
      .map((value) => String(value));

    const nestedProductIds = []
      .concat(Array.isArray(design.allowedProductIds) ? design.allowedProductIds : [])
      .concat(Array.isArray(design.allowed_product_ids) ? design.allowed_product_ids : []);

    const matrixProductIds = [];

    if (matrixArtwork.allowedApparel) {
      Object.values(matrixArtwork.allowedApparel).forEach((item) => {
        (item.productIds || []).forEach((productId) => {
          if (productId) matrixProductIds.push(String(productId));
        });
      });
    }

    if (matrixArtwork?.defaultApparel?.productId) {
      matrixProductIds.push(String(matrixArtwork.defaultApparel.productId));
    }

    const allowedIds = new Set(
      explicitProductIds
        .concat(nestedProductIds)
        .concat(matrixProductIds)
        .filter(Boolean)
        .map(String)
    );

    if (!allowedIds.size) {
      return library;
    }

    return library.filter((item) => allowedIds.has(String(item.productId)));
  }

  function getDefaultApparel(design) {
    const matrixArtwork = getMatrixArtworkForDesign(design);

    if (!matrixArtwork) {
      return getDefaultUnmappedApparelRecord();
    }

    const records = getAvailableApparelRecords(design);

    const defaultProductId = String(
      design.defaultProductId || design.default_product_id || ""
    );
    const defaultStyleId = String(
      design.defaultStyleId || design.default_style_id || ""
    );

    if (defaultProductId && defaultStyleId) {
      const direct = records.find(
        (item) =>
          String(item.productId) === defaultProductId &&
          String(item.styleId) === defaultStyleId
      );

      if (direct) return direct;
    }

    return (
      records.find((item) =>
        String(item.productId) === "1010290" &&
        String(item.styleId) === "1106313"
      ) ||
      records.find((item) =>
        item.category === "Short Sleeve T-Shirt" &&
        item.colorFamily === "White"
      ) ||
      records.find((item) => item.colorFamily === "White") ||
      records.find((item) => item.defaultStyle) ||
      records[0] ||
      DEFAULT_APPAREL
    );
  }


  function groupApparelByCategory(records) {
    const groups = [];

    records.forEach((record) => {
      if (!record || !record.category) return;

      let group = groups.find((item) => item.category === record.category);

      if (!group) {
        group = {
          category: record.category,
          records: [],
        };
        groups.push(group);
      }

      group.records.push(record);
    });

    groups.forEach((group) => {
      group.records.sort((a, b) => {
        const colorA = COLOR_FAMILY_ORDER.indexOf(a.colorFamily);
        const colorB = COLOR_FAMILY_ORDER.indexOf(b.colorFamily);

        return (
          (colorA === -1 ? 99 : colorA) -
            (colorB === -1 ? 99 : colorB) ||
          String(a.colorName).localeCompare(String(b.colorName))
        );
      });
    });

    return groups;
  }

  function getFirstRecordForCategory(records, category, currentRecord) {
    if (currentRecord && currentRecord.category === category) {
      return currentRecord;
    }

    return (
      records.find((item) => item.category === category && item.colorFamily === "White") ||
      records.find((item) => item.category === category && item.defaultStyle) ||
      records.find((item) => item.category === category) ||
      currentRecord
    );
  }

  function buildMockup(design, apparelRecord = DEFAULT_APPAREL, cardMode = false) {
    if (!apparelRecord) {
      return `<div class="di-product-mockup__placeholder">No approved apparel reference</div>`;
    }

    const artworkViews = getDesignArtworkViews(design);
    const viewsToRender = cardMode ? artworkViews.slice(0, 1) : artworkViews;

    const gridColumns =
      viewsToRender.length >= 4
        ? "repeat(2, minmax(0, 1fr))"
        : `repeat(${Math.max(1, viewsToRender.length)}, minmax(0, 1fr))`;

    const sideCards = viewsToRender
      .map((view) => {
        const matrixSide = getMatrixSideForDesign(design, view.side);
        const mockupUrl =
          matrixSide?.mockupUrlOverride ||
          getMockupUrlForSide(apparelRecord, view.side);
        const viewMode = cardMode ? "Grid" : "Modal";
        const artworkPlacementStyle = getMatrixPlacementStyle(design, view.side, viewMode, apparelRecord);
        const apparelPositionStyle = getMatrixApparelPositionStyle(design, view.side, viewMode, apparelRecord);

        return `
          <div class="di-product-mockup__view" data-view-side="${escapeHtml(view.side)}">
            <div
              class="di-product-mockup"
              data-product-id="${escapeHtml(apparelRecord.productId)}"
              data-style-id="${escapeHtml(apparelRecord.styleId)}"
              data-color="${escapeHtml(apparelRecord.colorName)}"
              data-side="${escapeHtml(view.side)}"
              data-apparel-category="${escapeHtml(apparelRecord.category)}"
              data-apparel-type="${escapeHtml(apparelRecord.type)}"
              data-mfg-sku="${escapeHtml(apparelRecord.mfgSku)}"
              data-matrix-applied="${getMatrixArtworkForDesign(design) ? "Yes" : "No"}"
              data-matrix-default-product-id="${escapeHtml(getMatrixArtworkForDesign(design)?.defaultApparel?.productId || "")}"
              data-matrix-default-style-id="${escapeHtml(getMatrixArtworkForDesign(design)?.defaultApparel?.styleId || "")}"
            >
              ${
                mockupUrl
                  ? `
                    <img
                      class="di-product-mockup__shirt"
                      src="${escapeHtml(mockupUrl)}"
                      ${apparelPositionStyle ? `style="${escapeHtml(apparelPositionStyle)}"` : ""}
                      data-matrix-apparel-position-style="${escapeHtml(apparelPositionStyle)}"
                      alt="${escapeHtml(apparelRecord.productName)} ${escapeHtml(view.side)} mockup"
                      loading="lazy"
                      onerror="this.style.display='none';"
                    >
                  `
                  : `<div class="di-product-mockup__placeholder">Missing ${escapeHtml(view.side)} mockup</div>`
              }

              ${
                view.artworkUrl
                  ? `
                    <img
                      class="di-product-mockup__artwork"
                      src="${escapeHtml(view.artworkUrl)}"
                      ${artworkPlacementStyle ? `style="${escapeHtml(artworkPlacementStyle)}"` : ""}
                      data-matrix-placement-preset="${escapeHtml(matrixSide?.placementPreset || matrixSide?.placementLabel || "")}"
                      data-matrix-placement-style="${escapeHtml(artworkPlacementStyle)}"
                      alt="${escapeHtml(design.title)} ${escapeHtml(view.side)} artwork"
                      loading="lazy"
                      data-fallback-srcs="${escapeHtml(
                        uniqueImageList([
                          ...(Array.isArray(view.fallbackUrls) ? view.fallbackUrls : []),
                          view.fallbackUrl,
                          ...(view.side === "Front"
                            ? [
                                getThumbnailArtwork(design),
                                normalizeImage(design.previewImageUrl),
                                normalizeImage(design.imageUrl),
                              ]
                            : []),
                        ]).join("||")
                      )}"
                      onerror="
                        const fallbackList = (this.dataset.fallbackSrcs || '').split('||').filter(Boolean);
                        const currentSrc = this.getAttribute('src') || '';
                        const nextSrc = fallbackList.find((src) => src && src !== currentSrc && src !== this.src);
                        if (nextSrc) {
                          this.dataset.fallbackSrcs = fallbackList.filter((src) => src !== nextSrc).join('||');
                          this.src = nextSrc;
                        } else {
                          this.style.display='none';
                        }
                      "
                    >
                  `
                  : ""
              }
            </div>

            ${cardMode ? "" : `<div class="di-product-mockup__caption">${escapeHtml(view.side)}</div>`}
          </div>
        `;
      })
      .join("");

    return `
      <div
        class="di-product-mockup-grid"
        data-side-count="${escapeHtml(viewsToRender.length)}"
        style="display:grid;grid-template-columns:${gridColumns};gap:20px;align-items:start;width:100%;"
      >
        ${sideCards}
      </div>
    `;
  }

  function repositionHomeSections() {
    const howSection = els.howItWorks?.closest(".di-section");
    const categorySection = els.primaryCategories?.closest(".di-section");

    if (!howSection || !categorySection || howSection === categorySection) return;

    // Place How It Works immediately before Browse by Category.
    categorySection.parentNode?.insertBefore(howSection, categorySection);
  }

  const IDENTIFIED_DESIGN_CATEGORIES = [
    "PE Uniforms",
    "Spirit Wear",
    "Athletics",
    "Clubs & Organizations",
    "Grad Apparel",
    "Events",
    "Seasonal",
    "Teachers & Staff",
    "Corporate",
  ];

  function normalizeDesignCategoryName(value) {
    const raw = String(value || "").trim();
    const key = raw.toLowerCase().replace(/\s+/g, " ");

    const aliases = {
      "club & organization": "Clubs & Organizations",
      "clubs & organization": "Clubs & Organizations",
      "clubs and organizations": "Clubs & Organizations",
      "club and organizations": "Clubs & Organizations",
      "graduation": "Grad Apparel",
      "graduate apparel": "Grad Apparel",
      "graduation apparel": "Grad Apparel",
      "teacher & staff": "Teachers & Staff",
      "teachers and staff": "Teachers & Staff",
      "teacher and staff": "Teachers & Staff",
      "corporate apparel": "Corporate",
      "seasonal apparel": "Seasonal",
    };

    return aliases[key] || raw;
  }

  function ensureCategoryRowStyles() {
    if (document.getElementById("di-category-row-overrides")) return;

    const style = document.createElement("style");
    style.id = "di-category-row-overrides";
    style.textContent = `
      #di-primary-categories.di-category-grid {
        display: grid !important;
        grid-auto-flow: column !important;
        grid-auto-columns: minmax(185px, 1fr) !important;
        grid-template-columns: none !important;
        gap: 12px !important;
        width: 100% !important;
        overflow-x: auto !important;
        overflow-y: hidden !important;
        padding: 2px 2px 12px !important;
        scroll-snap-type: x proximity;
        -webkit-overflow-scrolling: touch;
      }

      #di-primary-categories .di-category-card {
        min-width: 185px !important;
        height: 100% !important;
        scroll-snap-align: start;
      }

      #di-primary-categories::-webkit-scrollbar {
        height: 7px;
      }

      #di-primary-categories::-webkit-scrollbar-thumb {
        background: rgba(31, 75, 125, 0.28);
        border-radius: 999px;
      }

      @media (max-width: 700px) {
        #di-primary-categories.di-category-grid {
          grid-auto-columns: minmax(170px, 78vw) !important;
        }
      }
    `;

    document.head.appendChild(style);
  }

  function buildAllCategoryCards(designs, configuredCategories) {
    const categoryMap = new Map();

    // Always include the approved Unisource Apparel Originals taxonomy,
    // including categories that currently contain zero published designs.
    IDENTIFIED_DESIGN_CATEGORIES.forEach((title, index) => {
      categoryMap.set(title.toLowerCase(), {
        label: title,
        name: title,
        segment: title,
        designCount: 0,
        taxonomyIndex: index,
        url: `/pages/design-inspiration?segment=${encodeURIComponent(title)}`,
      });
    });

    // Preserve any endpoint-provided category metadata while retaining
    // the approved category label and display order above.
    (Array.isArray(configuredCategories) ? configuredCategories : []).forEach((category) => {
      const sourceTitle = String(
        category?.label || category?.name || category?.segment || ""
      ).trim();
      const title = normalizeDesignCategoryName(sourceTitle);

      if (!title) return;

      const key = title.toLowerCase();
      const existing = categoryMap.get(key) || {
        label: title,
        name: title,
        segment: title,
        designCount: 0,
        taxonomyIndex: IDENTIFIED_DESIGN_CATEGORIES.length,
      };

      categoryMap.set(key, {
        ...existing,
        ...category,
        label: title,
        name: title,
        segment: title,
        designCount: Number(existing.designCount || 0),
        taxonomyIndex: existing.taxonomyIndex,
        url:
          category?.url ||
          existing.url ||
          `/pages/design-inspiration?segment=${encodeURIComponent(title)}`,
      });
    });

    // Count every visible artwork under its normalized approved category.
    (Array.isArray(designs) ? designs : []).forEach((design) => {
      const sourceTitle = String(design?.segment || "").trim();
      const title = normalizeDesignCategoryName(sourceTitle);
      if (!title) return;

      const key = title.toLowerCase();
      const existing = categoryMap.get(key) || {
        label: title,
        name: title,
        segment: title,
        designCount: 0,
        taxonomyIndex: IDENTIFIED_DESIGN_CATEGORIES.length,
        url: `/pages/design-inspiration?segment=${encodeURIComponent(title)}`,
      };

      existing.designCount = Number(existing.designCount || 0) + 1;
      categoryMap.set(key, existing);
    });

    return Array.from(categoryMap.values()).sort((a, b) => {
      const orderDifference =
        Number(a.taxonomyIndex ?? IDENTIFIED_DESIGN_CATEGORIES.length) -
        Number(b.taxonomyIndex ?? IDENTIFIED_DESIGN_CATEGORIES.length);

      if (orderDifference !== 0) return orderDifference;

      return String(a.label || "").localeCompare(String(b.label || ""));
    });
  }

  function buildCategoryCard(category) {
    const title =
      category.label ||
      category.name ||
      category.segment ||
      "Design Category";

    const count =
      typeof category.designCount === "number"
        ? `${category.designCount} designs`
        : category.description || "";

    return `
      <a class="di-category-card" href="${escapeHtml(category.url || "#")}">
        <div class="di-category-card__title">${escapeHtml(title)}</div>
        <div class="di-category-card__count">${escapeHtml(count)}</div>
      </a>
    `;
  }

  function buildDesignCard(design) {
    const tags = (design.tags || [])
      .slice(0, 4)
      .map((tag) => `<span class="di-design-card__tag">${escapeHtml(tag)}</span>`)
      .join("");

    return `
      <div
        class="di-design-card"
        data-slug="${escapeHtml(design.slug)}"
        data-matrix-applied="${getMatrixArtworkForDesign(design) ? "Yes" : "No"}"
      >
        <div class="di-design-card__image-wrap">
          ${buildMockup(design, getDefaultApparel(design), true)}
        </div>

        <div class="di-design-card__body">
          <div class="di-design-card__segment">
            ${escapeHtml(design.segment || "")}
          </div>

          <div class="di-design-card__title">
            ${escapeHtml(design.title || "")}
          </div>

          <div class="di-design-card__meta">
            ${escapeHtml(design.collection || "")}
            ${design.productGroup ? ` • ${escapeHtml(design.productGroup)}` : ""}
          </div>

          <div class="di-design-card__tags">
            ${tags}
          </div>
        </div>

        <div class="di-design-card__actions">
          <button
            class="di-design-card__button"
            type="button"
            data-open-design="${escapeHtml(design.slug)}"
          >
            Visualize
          </button>
        </div>
      </div>
    `;
  }

  function renderHowItWorks(items) {
    if (!els.howItWorks || !Array.isArray(items)) return;

    els.howItWorks.innerHTML = items
      .map((item, index) => {
        return `
          <div class="di-how-card">
            <div class="di-how-card__number">${index + 1}</div>
            <div class="di-how-card__title">${escapeHtml(item.title)}</div>
            <div class="di-how-card__text">${escapeHtml(item.description)}</div>
          </div>
        `;
      })
      .join("");
  }


  const sectionState = {
    allDesigns: {
      items: [],
      page: 1,
      grid: () => els.allDesigns,
      pager: () => els.allDesignsPagination,
    },
  };

  function getPageCount(totalItems) {
    return Math.max(1, Math.ceil(totalItems / PAGE_SIZE));
  }

  function getVisiblePageNumbers(currentPage, pageCount) {
    if (pageCount <= 7) {
      return Array.from({ length: pageCount }, (_, index) => index + 1);
    }

    const pages = [1];

    if (currentPage > 4) {
      pages.push("ellipsis-start");
    }

    const start = Math.max(2, currentPage - 1);
    const end = Math.min(pageCount - 1, currentPage + 1);

    for (let page = start; page <= end; page += 1) {
      pages.push(page);
    }

    if (currentPage < pageCount - 3) {
      pages.push("ellipsis-end");
    }

    pages.push(pageCount);

    return pages;
  }

  function buildPagerButton({
    section,
    page,
    label,
    active = false,
    disabled = false,
    nav = false,
    action = "",
  }) {
    const actionAttribute = action
      ? ` data-di-page-action="${escapeHtml(action)}"`
      : "";

    return `
      <button
        type="button"
        class="di-page-btn${active ? " is-active" : ""}${nav ? " di-page-btn--nav" : ""}"
        data-di-page-section="${escapeHtml(section)}"
        data-di-page="${escapeHtml(page)}"${actionAttribute}
        ${active ? 'aria-current="page"' : ""}
        ${disabled ? "disabled" : ""}
      >
        ${escapeHtml(label)}
      </button>
    `;
  }

  function renderSectionPager(sectionName) {
    const state = sectionState[sectionName];
    if (!state) return;

    const pager = state.pager();
    if (!pager) return;

    const totalItems = state.items.length;
    const pageCount = getPageCount(totalItems);

    if (totalItems <= PAGE_SIZE) {
      pager.hidden = true;
      pager.innerHTML = "";
      return;
    }

    const pageNumbers = getVisiblePageNumbers(state.page, pageCount);

    const numberMarkup = pageNumbers
      .map((page) => {
        if (typeof page === "string") {
          return `<span class="di-pagination__ellipsis" aria-hidden="true">…</span>`;
        }

        return buildPagerButton({
          section: sectionName,
          page,
          label: String(page),
          active: page === state.page,
        });
      })
      .join("");

    const firstItem = (state.page - 1) * PAGE_SIZE + 1;
    const lastItem = Math.min(state.page * PAGE_SIZE, totalItems);

    pager.innerHTML = `
      <div class="di-pagination__summary">
        Showing ${firstItem}–${lastItem} of ${totalItems}
      </div>

      <div class="di-pagination__controls" role="navigation" aria-label="Design pages">
        ${buildPagerButton({
          section: sectionName,
          page: Math.max(1, state.page - 1),
          label: "Previous",
          disabled: state.page === 1,
          nav: true,
          action: "prev",
        })}

        <div class="di-pagination__numbers">
          ${numberMarkup}
        </div>

        ${buildPagerButton({
          section: sectionName,
          page: Math.min(pageCount, state.page + 1),
          label: "Next",
          disabled: state.page === pageCount,
          nav: true,
          action: "next",
        })}
      </div>
    `;

    pager.hidden = false;
  }

  function getSectionNameFromPagerElement(element) {
    const pager = element?.closest?.(".di-pagination");
    if (!pager) return "";

    if (pager.id === "di-all-designs-pagination") return "allDesigns";

    return "";
  }

  function setSectionPage(sectionName, requestedPage, scrollIntoView = false) {
    const state = sectionState[sectionName];
    if (!state) return false;

    const pageCount = getPageCount(state.items.length);
    const numericPage = Number(requestedPage);
    const nextPage = Math.min(
      pageCount,
      Math.max(1, Number.isFinite(numericPage) ? numericPage : state.page)
    );

    if (nextPage === state.page) return false;

    state.page = nextPage;
    renderSectionPage(sectionName, scrollIntoView);
    return true;
  }

  function getRequestedPageFromPagerButton(pageButton, state) {
    const pageCount = getPageCount(state.items.length);
    const action = pageButton.dataset.diPageAction || "";

    if (action === "next") return Math.min(pageCount, state.page + 1);
    if (action === "prev") return Math.max(1, state.page - 1);

    return Number(pageButton.dataset.diPage);
  }

  function buildDesignCardSafe(item, sectionName, pageNumber, itemIndex) {
    try {
      return buildDesignCard(item);
    } catch (error) {
      const title =
        item?.title ||
        item?.name ||
        item?.publicTitle ||
        item?.artworkTitle ||
        item?.slug ||
        "Design item";

      const designId =
        item?.inksoftDesignId ||
        item?.designId ||
        item?.id ||
        "";

      const errorInfo = {
        sectionName,
        pageNumber,
        itemIndex,
        designId: String(designId || ""),
        title: String(title || ""),
        message: error?.message || String(error),
      };

      window.__UNISOURCE_DI_CARD_RENDER_ERRORS__ =
        window.__UNISOURCE_DI_CARD_RENDER_ERRORS__ || [];
      window.__UNISOURCE_DI_CARD_RENDER_ERRORS__.push(errorInfo);

      console.warn("[Unisource DI] Card render skipped fallback:", errorInfo, error);

      return `
        <article class="di-design-card di-design-card--render-fallback" data-render-fallback="true">
          <div class="di-design-card__image">
            <div class="di-empty-state">Preview unavailable</div>
          </div>
          <div class="di-design-card__body">
            <div class="di-design-card__eyebrow">Needs review</div>
            <h3 class="di-design-card__title">${escapeHtml(title)}</h3>
            <p class="di-design-card__meta">
              This design could not render as a card. Check artwork, apparel, or matrix data.
            </p>
            ${designId ? `<p class="di-design-card__meta">Design ID: ${escapeHtml(designId)}</p>` : ""}
          </div>
        </article>
      `;
    }
  }

  function renderSectionPage(sectionName, scrollIntoView = false) {
    const state = sectionState[sectionName];
    if (!state) return;

    const grid = state.grid();
    if (!grid) return;

    const pageCount = getPageCount(state.items.length);
    const safePage = Math.min(Math.max(1, state.page), pageCount);
    state.page = safePage;

    const start = (safePage - 1) * PAGE_SIZE;
    const items = state.items.slice(start, start + PAGE_SIZE);

    let markup = "";

    try {
      markup = items.length
        ? items
            .map((item, index) =>
              buildDesignCardSafe(item, sectionName, safePage, start + index + 1)
            )
            .join("")
        : `<div class="di-empty-state">No designs are available in this section yet.</div>`;
    } catch (error) {
      window.__UNISOURCE_DI_LAST_PAGE_RENDER_ERROR__ = {
        sectionName,
        page: safePage,
        message: error?.message || String(error),
        time: new Date().toISOString(),
      };

      console.error("[Unisource DI] Page render failed:", window.__UNISOURCE_DI_LAST_PAGE_RENDER_ERROR__, error);

      markup = `
        <div class="di-empty-state">
          This page could not fully render. Please check the browser console for the design record causing the issue.
        </div>
      `;
    }

    grid.innerHTML = markup;

    renderSectionPager(sectionName);

    window.__UNISOURCE_DI_LAST_PAGE_RENDER__ = {
      sectionName,
      page: safePage,
      pageCount,
      startIndex: start + 1,
      itemCountOnPage: items.length,
      totalItems: state.items.length,
      time: new Date().toISOString(),
    };

    if (scrollIntoView) {
      const section = grid.closest(".di-section");
      if (section) {
        section.scrollIntoView({
          behavior: "smooth",
          block: "start",
        });
      }
    }
  }

  function setSectionItems(sectionName, items) {
    const state = sectionState[sectionName];
    if (!state) return;

    state.items = Array.isArray(items) ? items : [];
    state.page = 1;
    renderSectionPage(sectionName);
  }


  function extractDesignRecords(result) {
    const candidates = [
      result?.data?.records,
      result?.data?.designs,
      result?.data,
      result?.records,
      result?.designs,
    ];

    for (const candidate of candidates) {
      if (Array.isArray(candidate)) return candidate;
    }

    return [];
  }

  function normalizeSegment(value) {
    return String(value || "")
      .trim()
      .toLowerCase()
      .replace(/[_-]+/g, " ")
      .replace(/\s+/g, " ");
  }

  function isPESegment(design) {
    const value = normalizeSegment(design?.segment);
    return value === "pe uniforms" || value === "pe uniform";
  }

  function isSpiritSegment(design) {
    const value = normalizeSegment(design?.segment);
    return value === "spirit wear" || value === "spiritwear";
  }

  function dedupeDesigns(items) {
    const seen = new Set();

    return (Array.isArray(items) ? items : []).filter((item) => {
      const key =
        String(item?.inksoftDesignId || "") ||
        String(item?.slug || "") ||
        String(item?.id || "");

      if (!key || seen.has(key)) return false;
      seen.add(key);
      return true;
    });
  }

  function getDesignTimestamp(design) {
    const candidates = [
      design?.publishedAt,
      design?.publishDate,
      design?.updatedAt,
      design?.lastSyncedAt,
      design?.createdAt,
    ];

    for (const value of candidates) {
      const timestamp = Date.parse(value || "");
      if (Number.isFinite(timestamp)) return timestamp;
    }

    return 0;
  }

  function sortDesignsNewestFirst(items) {
    return [...items].sort((a, b) => {
      const dateDifference = getDesignTimestamp(b) - getDesignTimestamp(a);
      if (dateDifference !== 0) return dateDifference;

      const aId = Number(a?.inksoftDesignId || a?.designId || 0);
      const bId = Number(b?.inksoftDesignId || b?.designId || 0);
      if (aId !== bId) return bId - aId;

      return String(a?.title || "").localeCompare(String(b?.title || ""));
    });
  }

  function updateFeaturedScrollerButtons() {
    const scroller = els.featuredScroller;
    if (!scroller) return;

    const maxScrollLeft = Math.max(0, scroller.scrollWidth - scroller.clientWidth);
    const atStart = scroller.scrollLeft <= 2;
    const atEnd = scroller.scrollLeft >= maxScrollLeft - 2;

    if (els.featuredPrev) els.featuredPrev.disabled = atStart;
    if (els.featuredNext) els.featuredNext.disabled = atEnd || maxScrollLeft <= 2;
  }

  function renderFeaturedScroller(items) {
    if (!els.featuredScroller || !els.featuredSection) return;

    const featuredItems = (Array.isArray(items) ? items : [])
      .filter((item) => item?.featured === true)
      .slice(0, FEATURED_LIMIT);

    if (!featuredItems.length) {
      els.featuredSection.hidden = true;
      els.featuredScroller.innerHTML = "";
      return;
    }

    els.featuredSection.hidden = false;
    els.featuredScroller.innerHTML = featuredItems
      .map((item, index) => buildDesignCardSafe(item, "featured", 1, index + 1))
      .join("");

    requestAnimationFrame(updateFeaturedScrollerButtons);
  }

  function scrollFeatured(direction) {
    const scroller = els.featuredScroller;
    if (!scroller) return;

    const firstCard = scroller.querySelector(".di-design-card");
    const styles = window.getComputedStyle(scroller);
    const gap = Number.parseFloat(styles.columnGap || styles.gap || "20") || 20;
    const cardWidth = firstCard?.getBoundingClientRect().width || scroller.clientWidth / 4;
    const visibleCards = Math.max(1, Math.round(scroller.clientWidth / (cardWidth + gap)));
    const step = (cardWidth + gap) * visibleCards;

    scroller.scrollBy({
      left: direction * step,
      behavior: "smooth",
    });
  }

  function normalizeCategoryValue(value) {
    return String(value == null ? "" : value)
      .toLowerCase()
      .replace(/&/g, "and")
      .replace(/[^a-z0-9]+/g, " ")
      .trim();
  }

  /*
    IMPORTANT:
    Category pages must match only the record's PRIMARY `segment`.

    The backend's `segments` array can contain additional merged memberships
    when the same InkSoft Design ID appears in several source categories.
    Using that array caused unrelated designs to appear on this page.

    The main Design Inspiration page and category count use the primary
    category, so the category page must do the same.
  */
  function designBelongsToCategory(design, categoryName) {
    const wanted = normalizeCategoryValue(categoryName);
    const primarySegment = normalizeCategoryValue(design?.segment);

    if (!wanted || !primarySegment) return false;

    return primarySegment === wanted;
  }

  async function loadHome() {
    const designsResult = await fetchJson(`${API_BASE}/designs`);

    const categoryDesigns = sortDesignsNewestFirst(
      dedupeDesigns(extractDesignRecords(designsResult))
        .map(applyMatrixToDesign)
        .filter((design) => designBelongsToCategory(design, CATEGORY_NAME))
        .filter((design) => {
          const matrixArtwork = getMatrixArtworkForDesign(design);

          if (!matrixArtwork) return true;

          return (
            matrixArtwork.active !== false &&
            matrixArtwork.showInDesignGrid !== false
          );
        })
    );

    setSectionItems("allDesigns", categoryDesigns);

    const countElement = document.getElementById("di-category-count");
    if (countElement) {
      countElement.textContent =
        categoryDesigns.length === 1
          ? "1 design available"
          : `${categoryDesigns.length} designs available`;
    }

    return {
      total: categoryDesigns.length,
      featured: 0,
    };
  }

  async function loadDesign(slug) {
    const result = await fetchJson(
      `${API_BASE}/design/${encodeURIComponent(slug)}`
    );

    return result.data ? applyMatrixToDesign(result.data) : null;
  }

  function openModal() {
    if (!els.modal) return;
    els.modal.style.display = "block";
    els.modal.setAttribute("aria-hidden", "false");
  }

  function closeModal() {
    if (!els.modal) return;
    els.modal.style.display = "none";
    els.modal.setAttribute("aria-hidden", "true");
  }



  function asCleanString(value) {
    return value == null ? "" : String(value).trim();
  }

  function normalizeInksoftLaunchUrl(url) {
    let value = asCleanString(url);
    if (!value) return "";

    value = value.replace(
      /\/Unisource_Apparel\/Unisource_Apparel\//g,
      "/Unisource_Apparel/"
    );

    if (/^https?:\/\//i.test(value)) return value;
    if (value.indexOf("/Unisource_Apparel/") === 0) {
      return "https://shop.unisourceapparel.com" + value;
    }

    return value;
  }

  function normalizeInksoftDesignId(value) {
    const raw = asCleanString(value);
    if (!raw) return "";

    // Design Inspiration card IDs may use DI-1748938, while InkSoft
    // design-map requires the numeric InkSoft design ID: 1748938.
    const prefixedMatch = raw.match(/^DI[-_:]?(\d+)$/i);
    if (prefixedMatch && prefixedMatch[1]) return prefixedMatch[1];

    const numericMatch = raw.match(/(\d{6,})/);
    if (numericMatch && numericMatch[1]) return numericMatch[1];

    return raw.replace(/^DI[-_:]?/i, "");
  }

  function getVisualizerDesignId(design) {
    const candidates = [
      design && design.designId,
      design && design.DesignId,
      design && design.inksoftDesignId,
      design && design.artworkId,
      design && design.ArtworkId,
      design && design.matrixArtwork && design.matrixArtwork.designId,
      design && design.id,
      design && design.ID,
    ];

    for (const candidate of candidates) {
      const value = normalizeInksoftDesignId(candidate);
      if (value) return value;
    }

    return "";
  }

  function buildInksoftShareStudioUrl(productId, styleId, designId) {
    const safeProductId = asCleanString(productId);
    const safeStyleId = asCleanString(styleId);
    const safeDesignId = normalizeInksoftDesignId(designId);

    if (!safeProductId || !safeStyleId) return "";

    let url =
      "https://shop.unisourceapparel.com/Unisource_Apparel/shop/design-studio/share/" +
      encodeURIComponent(safeProductId) +
      "/" +
      encodeURIComponent(safeStyleId);

    if (safeDesignId) url += "/" + encodeURIComponent(safeDesignId);
    return url;
  }

  function buildDesignerWrapperUrl(productId, styleId, designId) {
    const params = new URLSearchParams();
    params.set("productId", asCleanString(productId));
    params.set("styleId", asCleanString(styleId));
    if (asCleanString(designId)) params.set("designId", asCleanString(designId));
    return "/pages/design-studio?" + params.toString();
  }

  async function resolveVisualizerMappedDesign(productId, styleId, templateDesignId) {
    const safeProductId = asCleanString(productId);
    const safeStyleId = asCleanString(styleId);
    const safeTemplateDesignId = normalizeInksoftDesignId(templateDesignId);

    if (!safeProductId || !safeStyleId || !safeTemplateDesignId) {
      return {
        success: false,
        reason: "Missing Product ID, Style ID, or template Design ID.",
        shareUrl: "",
        mappedDesignId: "",
        raw: null,
      };
    }

    if (
      !window.InksoftPOC ||
      !window.InksoftPOC.api ||
      typeof window.InksoftPOC.api.getDesignMap !== "function"
    ) {
      return {
        success: false,
        reason: "InksoftPOC.api.getDesignMap is unavailable.",
        shareUrl: "",
        mappedDesignId: "",
        raw: null,
      };
    }

    try {
      const payload = await window.InksoftPOC.api.getDesignMap({
        productId: safeProductId,
        styleId: safeStyleId,
        designId: safeTemplateDesignId,
      });

      const data = payload && payload.data ? payload.data : payload;
      const shareUrl = normalizeInksoftLaunchUrl(
        data && (
          data.shareUrl ||
          data.ShareUrl ||
          data.launchUrl ||
          data.LaunchUrl ||
          data.href ||
          data.Href ||
          ""
        )
      );
      const mappedDesignId = asCleanString(
        data && (
          data.mappedDesignId ||
          data.MappedDesignId ||
          data.designId ||
          data.DesignId ||
          data.id ||
          data.ID ||
          ""
        )
      );

      return {
        // Some backend versions return a valid shareUrl without success:true.
        success: Boolean(shareUrl),
        reason: asCleanString(data && (data.note || data.message || data.error)),
        shareUrl,
        mappedDesignId,
        raw: data || null,
      };
    } catch (error) {
      return {
        success: false,
        reason: error && error.message ? error.message : "Design mapping failed.",
        shareUrl: "",
        mappedDesignId: "",
        raw: null,
      };
    }
  }

  async function launchVisualizerDesignStudio(design, selectedRecord, trigger) {
    const productId = asCleanString(selectedRecord && selectedRecord.productId);
    const styleId = asCleanString(selectedRecord && selectedRecord.styleId);
    const templateDesignId = getVisualizerDesignId(design);

    if (!productId || !styleId || !templateDesignId) {
      setStatus(
        "Unable to open Design Online because the selected Product ID, Style ID, or Design ID is missing.",
        "error"
      );
      console.error("[Design Inspiration] Missing launch values", {
        productId,
        styleId,
        templateDesignId,
        selectedRecord,
        design,
      });
      return;
    }

    if (trigger) {
      trigger.setAttribute("aria-busy", "true");
      trigger.classList.add("is-loading");
      trigger.textContent = "Preparing Design Studio…";
    }

    try {
      const mapping = await resolveVisualizerMappedDesign(
        productId,
        styleId,
        templateDesignId
      );

      console.log("[Design Inspiration] Design-map response", {
        productId,
        styleId,
        templateDesignId,
        mapping,
      });

      /*
       * Launch priority:
       * 1. Verified mapped share URL returned by design-map.
       * 2. Direct InkSoft share URL built from the CURRENT Visualizer
       *    Product ID, Style ID, and normalized Design ID.
       *
       * Do not use selectedRecord.designOnlineUrl here. The curated apparel
       * library currently stores generic /design?productId=... URLs, which
       * reopen InkSoft at Select Product instead of loading the artwork.
       */
      const directLaunchUrl = buildInksoftShareStudioUrl(
        productId,
        styleId,
        templateDesignId
      );

      const finalDesignId = mapping.mappedDesignId || templateDesignId;
      const finalLaunchUrl = mapping.shareUrl || directLaunchUrl;

      if (!finalLaunchUrl) {
        throw new Error(
          mapping.reason ||
          "InkSoft could not prepare this artwork for the selected apparel and color."
        );
      }

      if (!mapping.shareUrl) {
        console.warn(
          "[Design Inspiration] No mapped design instance was returned; using direct InkSoft share fallback.",
          {
            productId,
            styleId,
            templateDesignId,
            mappingReason: mapping.reason || "",
            finalLaunchUrl,
          }
        );
      }

      closeModal();

      if (
        window.InksoftPOC &&
        window.InksoftPOC.designerEmbed &&
        typeof window.InksoftPOC.designerEmbed.open === "function"
      ) {
        window.InksoftPOC.designerEmbed.open({
          productId,
          styleId,
          designId: finalDesignId,
          templateDesignId,
          launchUrl: finalLaunchUrl,
          shareUrl: finalLaunchUrl,
          selectedShareUrl: finalLaunchUrl,
          // Important: prevent designerEmbed from replacing the valid
          // /share/... URL with the Shopify wrapper/select-product route.
          wrapperUrl: "",
        });
        return;
      }

      window.location.href = finalLaunchUrl;
    } catch (error) {
      console.error("[Design Inspiration] Unable to prepare Design Studio.", error);
      setStatus(
        error && error.message
          ? error.message
          : "Unable to prepare Design Studio. Please try again.",
        "error"
      );
      alert(
        error && error.message
          ? error.message
          : "Unable to prepare Design Studio. Please try again."
      );
    } finally {
      if (trigger && document.body.contains(trigger)) {
        trigger.removeAttribute("aria-busy");
        trigger.classList.remove("is-loading");
        trigger.textContent = "Design Online & Order";
      }
    }
  }

  function bindVisualizerControls(design) {
    const root = document.querySelector("[data-visualizer-root]");
    const preview = document.querySelector("[data-visualizer-preview]");
    const categoryLabel = document.querySelector("[data-visualizer-category-label]");
    const colorOptions = document.querySelector("[data-visualizer-color-options]");
    const styleInfo = document.querySelector("[data-visualizer-style-info]");
    const designOnlineLink = document.querySelector("[data-design-online-link]");

    if (!root || !preview) return;

    const availableRecords = getAvailableApparelRecords(design);
    const groups = groupApparelByCategory(availableRecords);

    let selectedRecord = getDefaultApparel(design);

    function refreshColorOptions() {
      if (!colorOptions || !selectedRecord) return;

      const records = availableRecords.filter(
        (item) => item.category === selectedRecord.category
      );

      colorOptions.innerHTML = records
        .map((item) => {
          return `
            <button
              type="button"
              class="di-visualizer__option${item.key === selectedRecord.key ? " is-active" : ""}"
              data-visualizer-style="${escapeHtml(item.key)}"
              title="${escapeHtml(item.colorName)}"
            >
              ${escapeHtml(item.colorName || item.colorFamily)}
            </button>
          `;
        })
        .join("");
    }

    function refresh() {
      if (!selectedRecord) return;

      preview.innerHTML = buildMockup(design, selectedRecord);

      root.querySelectorAll("[data-visualizer-category]").forEach((button) => {
        button.classList.toggle(
          "is-active",
          button.dataset.visualizerCategory === selectedRecord.category
        );
      });

      refreshColorOptions();

      if (categoryLabel) {
        categoryLabel.textContent = selectedRecord.category || "Apparel";
      }

      if (styleInfo) {
        const productDetailParams = new URLSearchParams();
        productDetailParams.set("id", asCleanString(selectedRecord.productId));

        if (asCleanString(selectedRecord.styleId)) {
          productDetailParams.set("styleId", asCleanString(selectedRecord.styleId));
        }

        if (asCleanString(selectedRecord.colorName)) {
          productDetailParams.set("color", asCleanString(selectedRecord.colorName));
        }

        const productDetailUrl = `/pages/inksoft-product?${productDetailParams.toString()}`;

        styleInfo.innerHTML = `
          <a
            class="di-visualizer__product-link"
            href="${escapeHtml(productDetailUrl)}"
            aria-label="View ${escapeHtml(selectedRecord.productName || "selected product")}"
          >
            <span class="di-visualizer__product-link-name">
              ${escapeHtml(selectedRecord.brand)} ${escapeHtml(selectedRecord.mfgSku)}
            </span>
            <span class="di-visualizer__product-link-meta">
              ${escapeHtml(selectedRecord.colorName)} · Product ID ${escapeHtml(selectedRecord.productId)} · Style ID ${escapeHtml(selectedRecord.styleId)}
            </span>
            <span class="di-visualizer__product-link-description">
              ${escapeHtml(selectedRecord.productName)}
            </span>
            <span class="di-visualizer__product-link-action">View product details →</span>
          </a>
        `;
      }

      if (designOnlineLink) {
        designOnlineLink.href = "#";
        designOnlineLink.dataset.productId = selectedRecord.productId || "";
        designOnlineLink.dataset.styleId = selectedRecord.styleId || "";
        designOnlineLink.dataset.designId = getVisualizerDesignId(design);
        designOnlineLink.removeAttribute("target");
        designOnlineLink.removeAttribute("rel");
      }
    }

    root.addEventListener("click", async (event) => {
      const designOnlineButton = event.target.closest("[data-design-online-link]");
      const categoryButton = event.target.closest("[data-visualizer-category]");
      const styleButton = event.target.closest("[data-visualizer-style]");

      if (designOnlineButton) {
        event.preventDefault();
        event.stopPropagation();
        await launchVisualizerDesignStudio(design, selectedRecord, designOnlineButton);
        return;
      }

      if (categoryButton) {
        const category = categoryButton.dataset.visualizerCategory;
        selectedRecord = getFirstRecordForCategory(
          availableRecords,
          category,
          selectedRecord
        );
        refresh();
        return;
      }

      if (styleButton) {
        const key = styleButton.dataset.visualizerStyle;
        const record = availableRecords.find((item) => item.key === key);

        if (record) {
          selectedRecord = record;
          refresh();
        }
      }
    });

    refresh();
  }

  async function showDesign(slug) {
    try {
      openModal();

      els.modalContent.innerHTML = `
        <div class="di-modal__loading">Loading design...</div>
      `;

      const design = await loadDesign(slug);

      if (!design) {
        els.modalContent.innerHTML = "<p>Design not found.</p>";
        return;
      }

      const availableRecords = getAvailableApparelRecords(design);
      const groups = groupApparelByCategory(availableRecords);
      const defaultRecord = getDefaultApparel(design);
      const artworkViews = getDesignArtworkViews(design);

      els.modalContent.innerHTML = `
        <div class="di-visualizer" data-visualizer-root>
          <div class="di-visualizer__preview" data-visualizer-preview>
            ${buildMockup(design, defaultRecord)}
          </div>

          <div class="di-visualizer__panel">
            <div class="di-visualizer__eyebrow">Visualize Design</div>

            <h2>${escapeHtml(design.title)}</h2>

            <p>${escapeHtml(design.description || "")}</p>

            <div class="di-visualizer__section">
              <div class="di-visualizer__label">Artwork Views</div>
              <div class="di-visualizer__meta">
                ${escapeHtml(artworkViews.map((item) => item.side).join(", ") || "Front")}
              </div>
            </div>

            <div class="di-visualizer__section">
              <div class="di-visualizer__label">Apparel Type</div>
              <div class="di-visualizer__options">
                ${groups
                  .map((group) => {
                    return `
                      <button
                        type="button"
                        class="di-visualizer__option"
                        data-visualizer-category="${escapeHtml(group.category)}"
                      >
                        ${escapeHtml(group.category)}
                      </button>
                    `;
                  })
                  .join("")}
              </div>
            </div>

            <div class="di-visualizer__section">
              <div class="di-visualizer__label">
                Colors for <span data-visualizer-category-label></span>
              </div>
              <div class="di-visualizer__options" data-visualizer-color-options></div>
            </div>

            <div class="di-visualizer__section">
              <div class="di-visualizer__label">Selected Product Reference</div>
              <div class="di-visualizer__meta" data-visualizer-style-info></div>
            </div>

            <div class="di-visualizer__actions">
              <a href="#" class="di-design-card__button" data-design-online-link>
                Design Online & Order
              </a>
            </div>
          </div>
        </div>
      `;

      bindVisualizerControls(design);
    } catch (error) {
      console.error(error);
      els.modalContent.innerHTML = `<p>Unable to load design.</p>`;
    }
  }


  function injectCuratedVisualizerStyles() {
    if (document.getElementById("di-curated-visualizer-styles")) return;

    const style = document.createElement("style");
    style.id = "di-curated-visualizer-styles";
    style.textContent = `
      /* v46: layout-only injected CSS. Artwork/apparel positioning comes from JSON. */

      .di-product-mockup-grid {
        width: 100%;
      }

      .di-product-mockup-grid[data-side-count="1"] { grid-template-columns: minmax(0, 1fr) !important; }
      .di-product-mockup-grid[data-side-count="2"] { grid-template-columns: repeat(2, minmax(0, 1fr)) !important; }
      .di-product-mockup-grid[data-side-count="3"] { grid-template-columns: repeat(3, minmax(0, 1fr)) !important; }
      .di-product-mockup-grid[data-side-count="4"] { grid-template-columns: repeat(2, minmax(0, 1fr)) !important; }

      /* Visualizer product reference link */
      .di-visualizer__product-link {
        display: flex !important;
        flex-direction: column !important;
        gap: 3px !important;
        padding: 8px 10px !important;
        margin: 3px -10px 0 !important;
        border: 1px solid transparent !important;
        border-radius: 8px !important;
        color: inherit !important;
        text-decoration: none !important;
        transition: background-color 160ms ease, border-color 160ms ease !important;
      }

      .di-visualizer__product-link:hover,
      .di-visualizer__product-link:focus-visible {
        background: #f4f7fb !important;
        border-color: #d7e1ef !important;
        text-decoration: none !important;
        outline: none !important;
      }

      .di-visualizer__product-link-name {
        color: #29496f !important;
        font-weight: 700 !important;
      }

      .di-visualizer__product-link-meta,
      .di-visualizer__product-link-description {
        color: #67778c !important;
      }

      .di-visualizer__product-link-action {
        margin-top: 3px !important;
        color: #194f8f !important;
        font-weight: 700 !important;
      }

      /* Keep Design Online & Order centered in every state */
      .di-visualizer__actions .di-design-card__button,
      [data-design-online-link] {
        display: flex !important;
        align-items: center !important;
        justify-content: center !important;
        width: 100% !important;
        min-height: 42px !important;
        padding: 11px 18px !important;
        text-align: center !important;
        line-height: 1.2 !important;
        white-space: normal !important;
      }

      .di-product-mockup {
        position: relative !important;
        display: block !important;
        width: 100% !important;
        min-height: 620px !important;
        overflow: hidden !important;
        border-radius: 16px !important;
        background: #f7f9fc !important;
      }

      .di-design-card .di-product-mockup {
        min-height: 378px !important;
        border-radius: 12px !important;
      }

      .di-product-mockup__shirt {
        z-index: 1 !important;
        display: block !important;
        object-fit: contain !important;
        opacity: 1 !important;
      }

      .di-product-mockup__artwork {
        position: absolute !important;
        z-index: 2 !important;
        height: auto !important;
        object-fit: contain !important;
        background: transparent !important;
        filter: drop-shadow(0 2px 3px rgba(15, 23, 42, .18)) !important;
        pointer-events: none !important;
      }

      .di-design-card .di-product-mockup-grid {
        height: 100% !important;
        align-items: center !important;
      }

      .di-design-card .di-product-mockup__view {
        height: 100% !important;
        display: flex !important;
        align-items: center !important;
        justify-content: center !important;
      }

      .di-design-card__image-wrap {
        min-height: 372px !important;
        overflow: hidden !important;
      }

      .di-modal__dialog {
        width: min(97vw, 1420px) !important;
        max-width: 1420px !important;
      }

      .di-modal__content {
        align-items: start !important;
      }

      .di-modal .di-visualizer {
        grid-template-columns: minmax(0, 1.78fr) minmax(340px, 0.78fr) !important;
        gap: 32px !important;
      }

      .di-modal .di-visualizer__preview {
        min-width: 0 !important;
        width: 100% !important;
        min-height: auto !important;
        height: auto !important;
        padding: 14px 18px 10px !important;
        align-items: flex-start !important;
      }

      .di-modal .di-visualizer__preview .di-product-mockup-grid {
        margin: 0 auto !important;
        width: 100% !important;
      }

      .di-modal .di-visualizer__preview .di-product-mockup-grid[data-side-count="2"] {
        gap: 28px !important;
        align-items: start !important;
        margin-bottom: 0 !important;
      }

      .di-modal .di-visualizer__preview .di-product-mockup {
        min-height: 500px !important;
        max-height: 540px !important;
      }

      .di-product-mockup__caption,
      .di-visualizer__preview .di-product-mockup__caption,
      .di-modal .di-visualizer__preview .di-product-mockup__caption {
        margin-top: 4px !important;
      }

      .di-visualizer__option {
        line-height: 1.15 !important;
      }

      @media (max-width: 760px) {
        .di-modal__dialog {
          width: 100vw !important;
          max-width: 100vw !important;
        }

        .di-modal .di-visualizer {
          grid-template-columns: minmax(0, 1fr) !important;
          gap: 20px !important;
        }

        .di-product-mockup-grid,
        .di-product-mockup-grid[data-side-count] {
          grid-template-columns: minmax(0, 1fr) !important;
        }
      }
    `;
    document.head.appendChild(style);
  }

  function recordLastClickTarget(event) {
    const element = event.target;
    window.__UNISOURCE_DI_LAST_CLICK_TARGET__ = {
      tag: element?.tagName || "",
      id: element?.id || "",
      className: String(element?.className || ""),
      text: String(element?.textContent || "").trim().slice(0, 80),
      isPagerButton: Boolean(element?.closest?.("[data-di-page-section][data-di-page]")),
      time: new Date().toISOString(),
    };
  }

  function handlePaginationClick(event) {
    recordLastClickTarget(event);
    const pageButton = event.target.closest?.("[data-di-page-section][data-di-page]");
    if (!pageButton) return false;

    const sectionName =
      pageButton.dataset.diPageSection || getSectionNameFromPagerElement(pageButton);
    const state = sectionState[sectionName];

    if (!state) return false;

    event.preventDefault();
    event.stopPropagation();
    event.stopImmediatePropagation();

    const beforePage = state.page;
    const requestedPage = getRequestedPageFromPagerButton(pageButton, state);
    const changed = setSectionPage(sectionName, requestedPage, false);

    window.__UNISOURCE_DI_LAST_PAGER_EVENT__ = {
      version: window.__UNISOURCE_DI_ACTIVE_VERSION__,
      sectionName,
      action: pageButton.dataset.diPageAction || "number",
      buttonPage: pageButton.dataset.diPage,
      beforePage,
      requestedPage,
      afterPage: state.page,
      changed,
      itemCount: state.items.length,
      pageCount: getPageCount(state.items.length),
      time: new Date().toISOString(),
    };

    return true;
  }

  function bindEvents() {
    /*
      v61:
      Capture-phase pagination handler prevents stale bubbling handlers or older
      cached script instances from double-processing pager clicks.
    */
    if (!window.__UNISOURCE_DI_CAPTURE_PAGER_BOUND__) {
      document.addEventListener("click", handlePaginationClick, true);
      window.__UNISOURCE_DI_CAPTURE_PAGER_BOUND__ = true;
    }

    document.addEventListener("click", async (event) => {
      const pageButton = event.target.closest("[data-di-page-section][data-di-page]");

      if (pageButton) {
        /*
          Pagination is handled in capture phase by handlePaginationClick().
          Keep this guard only as a fallback if capture was blocked.
        */
        handlePaginationClick(event);
        return;
      }

      const button = event.target.closest("[data-open-design]");

      if (button) {
        event.preventDefault();
        const slug = button.dataset.openDesign;

        if (slug) {
          await showDesign(slug);
        }
      }
    });

    if (els.featuredPrev) {
      els.featuredPrev.addEventListener("click", () => scrollFeatured(-1));
    }

    if (els.featuredNext) {
      els.featuredNext.addEventListener("click", () => scrollFeatured(1));
    }

    if (els.featuredScroller) {
      els.featuredScroller.addEventListener("scroll", updateFeaturedScrollerButtons, { passive: true });
      window.addEventListener("resize", updateFeaturedScrollerButtons, { passive: true });
    }

    if (els.modalClose) {
      els.modalClose.addEventListener("click", closeModal);
    }

    if (els.modal) {
      els.modal.addEventListener("click", (event) => {
        if (event.target === els.modal) {
          closeModal();
        }
      });
    }
  }

  window.UNISOURCE_DI_PAGINATION_LISTENERS_NOTE =
    "v69 uses capture-phase pagination for the All Design Ideas section.";

  window.UNISOURCE_DI_LAST_CLICK_TARGET = function () {
    return window.__UNISOURCE_DI_LAST_CLICK_TARGET__ || null;
  };

  window.UNISOURCE_DI_CARD_RENDER_ERRORS = function () {
    return window.__UNISOURCE_DI_CARD_RENDER_ERRORS__ || [];
  };

  window.UNISOURCE_DI_LAST_PAGE_RENDER = function () {
    return window.__UNISOURCE_DI_LAST_PAGE_RENDER__ || null;
  };

  window.UNISOURCE_DI_VERSION = function () {
    return {
      version: window.__UNISOURCE_DI_ACTIVE_VERSION__ || "unknown",
      capturePagerBound: Boolean(window.__UNISOURCE_DI_CAPTURE_PAGER_BOUND__),
      lastPagerEvent: window.__UNISOURCE_DI_LAST_PAGER_EVENT__ || null,
    };
  };

  window.UNISOURCE_DI_PAGINATION_INFO = function () {
    const info = Object.entries(sectionState).map(([section, state]) => ({
      section,
      page: state.page,
      itemCount: state.items.length,
      pageCount: getPageCount(state.items.length),
      pagerId: state.pager()?.id || "",
    }));

    console.table(info);
    return info;
  };

  window.UNISOURCE_DI_FORCE_PAGE = function (sectionName, pageNumber) {
    return setSectionPage(sectionName, Number(pageNumber), false);
  };

  window.UNISOURCE_DI_MATRIX_INFO = function () {
    const info = {
      matrixUrl: DI_MATRIX_URL,
      matrixLoaded: Boolean(DESIGN_MATRIX),
      matrixCounts: DESIGN_MATRIX?.counts || null,
      indexedDesignIds: DESIGN_MATRIX_BY_ID?.size || 0,
      indexedTitles: DESIGN_MATRIX_BY_TITLE?.size || 0,
    };

    console.table([info]);
    return info;
  };

  window.UNISOURCE_DI_DEBUG_MATRIX = function () {
    const cards = Array.from(document.querySelectorAll(".di-design-card")).map((card) => {
      const mockup = card.querySelector(".di-product-mockup");
      const artwork = card.querySelector(".di-product-mockup__artwork");
      const title = card.querySelector(".di-design-card__title")?.textContent?.trim() || "";

      return {
        title,
        matrixApplied: card.dataset.matrixApplied || mockup?.dataset.matrixApplied || "",
        productId: mockup?.dataset.productId || "",
        styleId: mockup?.dataset.styleId || "",
        matrixDefaultProductId: mockup?.dataset.matrixDefaultProductId || "",
        matrixDefaultStyleId: mockup?.dataset.matrixDefaultStyleId || "",
        placementPreset: artwork?.dataset.matrixPlacementPreset || "",
        placementStyle: artwork?.dataset.matrixPlacementStyle || "",
        apparelPositionStyle:
          mockup?.querySelector(".di-product-mockup__shirt")?.dataset
            .matrixApparelPositionStyle || "",
      };
    });

    console.table(cards);
    return cards;
  };

  async function init() {
    try {
      injectCuratedVisualizerStyles();
      showLoader();
      setStatus(`Loading ${CATEGORY_NAME || "category"} designs...`);
      await loadDesignMatrix();
      const counts = await loadHome();
      setStatus(
        `${CATEGORY_NAME || "Category"} ready — ${counts.total} designs loaded.`,
        "success"
      );
    } catch (error) {
      console.error("[Design Category Page]", error);
      setStatus(
        `Unable to load ${CATEGORY_NAME || "category"} designs.`,
        "error"
      );

      const countElement = document.getElementById("di-category-count");
      if (countElement) {
        countElement.textContent = "Designs could not be loaded.";
      }
    } finally {
      hideLoader();
    }
  }

  bindEvents();
  init();
})();